//@ts-nocheck

import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Avatar,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Stack,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import call from "../../assets/images/phone-call.png";
import roles from "../../assets/images/role-model.png";
import tick from "../../assets/images/check-mark.png";
import crs from "../../assets/images/cross.png";
import log from "../../assets/images/profile.png";
import emails from "../../assets/images/gmail.png";
import genders from "../../assets/images/symbol.png";
import dobs from "../../assets/images/timetable.png";
import id from "../../assets/images/profile1.png";
import settings from "../../assets/images/settings.png";
import trans from "../../assets/images/translation.png";
import logout from "../../assets/images/logout.png";
import logged from "../../assets/images/permission.png";
import logo from "../../assets/images/recyclebinLogo.png";
import help from "../../assets/images/help.png";
import loged from "../../assets/images/DrawerLogo.png";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { Home } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";
import Typewriter from "./TypeWriter";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import FolderIcon from "@mui/icons-material/Folder";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import "./Shine.css";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import GrainIcon from "@mui/icons-material/Grain";
import names from "../../assets/images/id-card (2).png";
import backgrd from "../../assets/images/backgroundimage.jpg";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
} from "@mui/material";
import "./ThemeStyle.css";
import ThemeIcon from "../../assets/images/themes.png";
import {
  Brightness5,
  Brightness4,
  Waves,
  WbSunny,
  Forest,
  Flag,
} from "@mui/icons-material";
import api from "../../utils/Url";
import { toast } from "react-toastify";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import TreeView from "@mui/x-tree-view/TreeView";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { FaRegFolderOpen } from "react-icons/fa6";
import DescriptionIcon from '@mui/icons-material/Description';
import { FaFileLines } from "react-icons/fa6";
import { Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { logout as logoutAction } from '../../redux/userSlice';

const drawerWidth = 225;

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "85%",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function getGreeting() {
  const hour = new Date().getHours();

  let greeting;
  if (hour < 12) {
    greeting = {
      text: "Good Morning",
      color: "#FFFFE0",
      icon: "🌅",
    };
  } else if (hour < 17) {
    greeting = {
      text: "Good Afternoon",
      color: "#FFE4B5",
      icon: "🌞",
    };
  } else {
    greeting = {
      text: "Good Evening",
      color: "#FFDAB9",
      icon: "🌜",
    };
  }

  return greeting;
}

interface MenuItem {
  menuId: number;
  menuName: string;
  parentId: number | null;
  pageUrl: string | null;
  icon: string | null;
  displayNo: number | null;
  isMenu: boolean;
  isAdd: boolean;
  isEdit: boolean;
  isDel: boolean;
  isView: boolean | null;
  isPrint: boolean;
  isExport: boolean;
  isRelease: boolean;
  isPost: boolean;
  vtsCombine: any;
  hasSubMenu: boolean;
  children?: MenuItem[];
  path?: string;
  permissions?: {
    isAdd: boolean;
    isEdit: boolean;
    isDel: boolean;
    isView: boolean | null;
    isPrint: boolean;
    isExport: boolean;
    isRelease: boolean;
    isPost: boolean;
  };
}

interface SidebarProps {
  items: MenuItem[];
  onClick?: (e: any, item: any) => void;
}

// Separate clock component to prevent re-renders
const ClockComponent = React.memo(() => {
  const [date, setDate] = React.useState(new Date());

  React.useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const formattedDate = date
    .toLocaleDateString("en-US", options)
    .split(" ")
    .map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
    )
    .join(" ");

  return (
    <>
      <p> Time : {date.toLocaleTimeString()}</p>
      <p> Date : {formattedDate}</p>
    </>
  );
});

ClockComponent.displayName = 'ClockComponent';

function MiniDrawer({ items, onClick }: SidebarProps) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  // UPDATED: Set sidebar closed by default
  const [open, setOpen] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [profileDrawerOpen, setProfileDrawerOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [collapseIndex, setCollapseIndex] = React.useState<any>(-1);
  // UPDATED: Set openlogo to false when sidebar is closed
  const [openlogo, setOpenlogo] = React.useState(false);
  const [homeColor, setHomeColor] = React.useState("inherit");
  const { t } = useTranslation();

  const [selectedSubMenu, setSelectedSubMenu] = React.useState(null);
  const [expandedItems, setExpandedItems] = React.useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [treedata, setTreedata] = React.useState<any>([]);
  const [check, setCheck] = React.useState<any>([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [filteredItems, setFilteredItems] = React.useState<MenuItem[]>([]);
  const [activeMenu, setActiveMenu] = React.useState<number | null>(null);

  // Use state for open menus to trigger re-renders
  const [openMenus, setOpenMenus] = React.useState<Set<number>>(new Set());

  const themes = [
    { name: "light-theme", icon: <Brightness5 /> },
    { name: "dark-theme", icon: <Brightness4 /> },
    { name: "ocean-theme", icon: <Waves /> },
    { name: "sunset-theme", icon: <WbSunny /> },
    { name: "forest-theme", icon: <Forest /> },
    { name: "bhagwa-theme", icon: <Flag /> },
  ];

  // Get user details from Redux store
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);

  // Get user data safely
  const getUserData = () => {
    if (userDetails) {
      return userDetails;
    }

    // Fallback to localStorage
    try {
      const storedUserDetails = localStorage.getItem('userDetails');
      if (storedUserDetails) {
        return JSON.parse(storedUserDetails);
      }
    } catch (error) {
      console.error('Error parsing user details from localStorage:', error);
    }

    return null;
  };

  const menuData = getUserData();

  const greeting = getGreeting();

  // Function definitions that were missing
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = () => {
    toast.success("Save functionality");
    handleCloseModal();
  };

  const renderTree = (nodes: any) => (
    <TreeItem
      key={nodes.id}
      itemId={String(nodes.id)}
      label={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            checked={check.indexOf(nodes.id) !== -1}
            onChange={() => { }}
            onClick={(event: any) => event.stopPropagation()}
          />
          <div style={{ marginLeft: 8 }}>{nodes.name}</div>
        </div>
      }
      onClick={() => { }}
    >
      {Array.isArray(nodes.childnode)
        ? nodes.childnode.map((node: any) => renderTree(node))
        : null}
    </TreeItem>
  );

  // Other existing function definitions
  function searchMenuItems(items: any, query: string) {
    const results = [];

    for (const menuItem of items) {
      if (menuItem.menuName?.toLowerCase().includes(query.toLowerCase())) {
        results.push(menuItem);
      } else if (menuItem.children && menuItem.children.length > 0) {
        const matchingSubItems = menuItem.children.filter(
          (subItem: { menuName: string }) =>
            subItem.menuName?.toLowerCase().includes(query.toLowerCase())
        );
        if (matchingSubItems.length > 0) {
          results.push({ ...menuItem, children: matchingSubItems });
        }
      }
    }
    return results;
  }

  const handleSearchIconClick = () => {
    const filtered = searchMenuItems(items, searchValue);
    setFilteredItems(filtered);
  };

  const handleNavigation = (path: any) => {
    navigate(path);
  };

  const handleAutocompleteChange = (event: any, value: any) => {
    const selectedItem = items.find((item: any) =>
      item.children?.some((subItem: any) => subItem.menuName === value)
    );
    if (selectedItem) {
      const selectedSubItem = selectedItem.children.find(
        (subItem: any) => subItem.menuName === value
      );
      if (selectedSubItem) {
        handleNavigation(selectedSubItem.path);
      }
    }
  };

  const allMenuNames = items.reduce((acc: any, item: { children: any[] }) => {
    if (item.children) {
      return [
        ...acc,
        ...item.children.map((subItem: { menuName: any }) => subItem.menuName),
      ];
    }
    return acc;
  }, []);

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(value);

    const expandedMenuIds: any = new Set();

    if (value === "") {
      setFilteredItems(items);
      setOpenMenus(new Set());
      return;
    }

    const filtered = items.reduce((acc: any, menu: any) => {
      if (menu.menuName?.toLowerCase().includes(value)) {
        acc.push(menu);
        expandedMenuIds.add(menu.menuId);
      } else if (menu.children) {
        const filteredChildren = menu.children.filter((child: any) =>
          child.menuName?.toLowerCase().includes(value)
        );

        if (filteredChildren.length > 0) {
          acc.push({ ...menu, children: filteredChildren });
          expandedMenuIds.add(menu.menuId);
        }
      }
      return acc;
    }, []);

    setFilteredItems(filtered);
    setOpenMenus(expandedMenuIds);
  };

  var [date, setDate] = React.useState(new Date());

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const formattedDate = date
    .toLocaleDateString("en-US", options)
    .split(" ")
    .map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
    )
    .join(" ");

  React.useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  const resetHomeColor = () => {
    setHomeColor("#FF0000");
  };

  // FIXED: Updated handleMenuClick function
  const handleMenuClick = (menu: any, e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    console.log('=== MENU CLICK START ===');
    console.log('Menu clicked:', menu.menuName, 'ID:', menu.menuId);
    console.log('Has children:', menu.children?.length > 0);
    console.log('Current open menus:', Array.from(openMenus));

    // Update active menu
    setActiveMenu(menu.menuId);

    if (menu.children && menu.children.length > 0) {
      // This is a folder - toggle expand/collapse
      console.log('Toggling folder:', menu.menuName);

      // Toggle the menu
      setOpenMenus(prev => {
        const newOpenMenus = new Set(prev);
        if (newOpenMenus.has(menu.menuId)) {
          newOpenMenus.delete(menu.menuId);
          console.log('Closing menu:', menu.menuId);
        } else {
          // If it's a top-level menu (parentId === null), close other top-level menus
          if (menu.parentId === null) {
            // Only close other top-level menus
            const otherTopLevelMenus = Array.from(newOpenMenus).filter(id => {
              const menuItem = findMenuItem(items, id);
              return menuItem && menuItem.parentId === null && id !== menu.menuId;
            });
            otherTopLevelMenus.forEach(id => newOpenMenus.delete(id));
          }
          newOpenMenus.add(menu.menuId);
          console.log('Opening menu:', menu.menuId);
        }

        console.log('New open menus:', Array.from(newOpenMenus));
        return newOpenMenus;
      });

      // Store permissions for this menu item even though we're not navigating
      const testPermissions = {
        isAdd: true,
        isEdit: true,
        isDel: true,
        isView: true,
        isPrint: true,
        isExport: true,
        isRelease: true,
        isPost: true
      };

      sessionStorage.setItem("menuId", menu.menuId.toString());
      sessionStorage.setItem("menuName", menu.menuName);
      sessionStorage.setItem("menuPermissions", JSON.stringify(testPermissions));

      // If onClick prop is provided, call it after handling the toggle
      if (onClick) {
        onClick(e || null, menu);
      }
    } else {
      // This is a leaf node - navigate
      console.log('Navigating to leaf node');

      sessionStorage.setItem("menuId", menu.menuId.toString());
      sessionStorage.setItem("menuName", menu.menuName);
      sessionStorage.setItem("menuPermissions", JSON.stringify(menu.permissions || {}));

      // If onClick prop is provided, use it
      if (onClick) {
        onClick(e || null, menu);
      } else {
        // Fallback navigation
        const path = menu.path || `/${menu.menuName?.replace(/\s+/g, "").toLowerCase()}`;
        navigate(`${path}?appId=${menu.menuId}&Appname=${menu.menuName}.aspx`);
      }
    }

    console.log('=== MENU CLICK END ===');
  };

  // Helper function to find a menu item by ID
  const findMenuItem = (menuList: any[], id: number): any => {
    for (const item of menuList) {
      if (item.menuId === id) return item;
      if (item.children) {
        const found = findMenuItem(item.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  // UPDATED: renderMenu function with Tooltip that always shows on hover
  const renderMenu = (menus: any[], level = 0) => {
    if (!menus || menus.length === 0) {
      return (
        <Typography sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
          No menus available
        </Typography>
      );
    }

    return menus.map((menu: any) => {
      const hasChildren = menu.children && menu.children.length > 0;
      const isOpen = openMenus.has(menu.menuId);
      const menuName = menu.menuName || 'Unnamed Menu';

      return (
        <React.Fragment key={`${menu.menuId}-${level}`}>
          {/* FIXED: Tooltip always shows on hover regardless of sidebar state */}
          <Tooltip
            title={menuName}
            placement="right"
            arrow
          >
            <div>
              <ListItem
                disablePadding
                sx={{
                  display: "block",
                  backgroundColor: activeMenu === menu.menuId ? "#dfe6f5" : "inherit",
                  "&:hover": { backgroundColor: "#f8f9fa" },
                  borderRadius: "6px",
                  transition: "background 0.2s ease-in-out",
                  marginBottom: "2px",
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    pl: level * 2 + (open ? 2.5 : 1.5),
                  }}
                  onClick={(e) => handleMenuClick(menu, e)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 2 : "auto",
                      justifyContent: "center",
                      color: activeMenu === menu.menuId ? "#FF0000" : "#333",
                    }}
                  >
                    {hasChildren ? (
                      isOpen ? (
                        <FaRegFolderOpen style={{ color: "#42AEEE", fontSize: "18px" }} />
                      ) : (
                        <FolderIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
                      )
                    ) : (
                      <DescriptionIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
                    )}
                  </ListItemIcon>

                  <ListItemText
                    primary={menuName}
                    sx={{
                      opacity: open ? 1 : 0,
                      fontWeight: "bold",
                      fontSize: "13px",
                      color: activeMenu === menu.menuId ? "#0056b3" : "#333",
                      "& .MuiListItemText-primary": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }
                    }}
                  />

                  {hasChildren && open && (
                    <Box sx={{ ml: 1 }}>
                      {isOpen ? (
                        <ExpandLessIcon fontSize="small" style={{ color: "#42AEEE" }} />
                      ) : (
                        <ExpandMoreIcon fontSize="small" style={{ color: "#42AEEE" }} />
                      )}
                    </Box>
                  )}
                </ListItemButton>
              </ListItem>
            </div>
          </Tooltip>

          {/* Render children if menu is open */}
          {hasChildren && isOpen && (
            <Collapse
              in={isOpen}
              timeout="auto"
              unmountOnExit
              sx={{ pl: 2 }}
            >
              <List component="div" disablePadding>
                {renderMenu(menu.children, level + 1)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
    setHomeColor("inherit");
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const routeChangeHome = () => {
    navigate(`/home`);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    setOpenlogo(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setOpenlogo(false);
  };

  const handleLogout = () => {
    dispatch(logoutAction());
    sessionStorage.clear();
    navigate("/");
  };

  const { i18n } = useTranslation();

  const changeLanguage = (language: any) => {
    i18n.changeLanguage(language);
    localStorage.setItem("preferredLanguage", language);
  };

  var currentLanguage = localStorage.getItem("preferredLanguage");
  var newLanguage = currentLanguage === "hi" ? "English" : "हिंदी";

  const collapsehamndle = (index: any) => {
    if (index == collapseIndex) {
      setCollapseIndex(-1);
    } else {
      setCollapseIndex(index);
    }
  };

  const getImageForFirstName = (userName: string) => {
    const firstLetter = userName ? userName.charAt(0).toUpperCase() : "";
    return `${firstLetter}`;
  };

  const getGenderText = (gendeR_ID: any) => {
    switch (gendeR_ID) {
      case 1:
        return "Male";
      case 2:
        return "Female";
      case 3:
        return "Other";
      default:
        return "Unknown";
    }
  };

  const handleMyProfileClick = () => {
    setProfileDrawerOpen(!profileDrawerOpen);
  };

  const currentPathname = window.location.pathname;
  const segments = currentPathname.split("/").filter(Boolean);

  function handleClicked(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    event.preventDefault();
  }

  const handleClickhome = () => {
    navigate(`/home`);
  };

  const handleRightClick = (path: any) => (e: any) => {
    e.preventDefault();
    window.open(path, "_blank");
  };

  const [showThemeMenu, setShowThemeMenu] = React.useState(false);
  const [selectedTheme, setSelectedTheme] = React.useState(() => {
    const storedTheme = localStorage.getItem("theme");
    return storedTheme ? storedTheme : themes[0]["name"];
  });

  React.useEffect(() => {
    document.body.className = selectedTheme;
    localStorage.setItem("theme", selectedTheme);
  }, [selectedTheme]);

  const handleThemeChange = (theme: any) => {
    setSelectedTheme(theme);
    setShowThemeMenu(false);
  };

  const handleCloseSelect = () => {
    setShowThemeMenu(false);
  };

  const headerColor1 = `var(--header-background)`;
  const drawerStyles = `var(--drawer-background)`;

  // Don't render the sidebar if user is not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" open={open} style={{}}>
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: `var(--header-background1)`,
            color: `var(--header-color1)`,
            borderBottom: "1px solid",
            borderImage: "linear-gradient(to right,rgb(240, 123, 6), #FFFFFF,rgb(30, 239, 11)) 1",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon fontSize="large" />
            </IconButton>

            {!openlogo && <img src={logo} width={60} height={60} alt="Logo" />}
          </div>

          <div style={{ fontFamily: "Georgia, serif" }}>
            <span style={{ fontSize: "3vw", color: "#FF671F" }}>V</span>
            <span style={{ fontSize: "2.2vw" }}>ehicle </span>
            <span style={{ fontSize: "3vw", color: "#D50E00" }}>T</span>
            <span style={{ fontSize: "2.2vw" }}>racking </span>
            <span style={{ fontSize: "3vw", color: "#FFE100" }}>S</span>
            <span style={{ fontSize: "2.2vw" }}>ystem</span>
          </div>

          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 40, height: 40 }}>
              {menuData?.userName ? menuData.userName[0].toUpperCase() : 'U'}
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={menuOpen}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                backgroundColor: `var(--menu-background)`,
                color: `var(--menu-color)`,
                overflow: "auto",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                paddingRight: "10px",
                paddingLeft: "10px",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&::before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <img src={logged} width={40} height={40} alt="User" />
              </ListItemIcon>
              {menuData?.userName || "User"}
            </MenuItem>

            <MenuItem onClick={handleMyProfileClick}>
              <ListItemIcon>
                <img src={id} width={30} height={30} alt="Profile" />
              </ListItemIcon>
              My Profile
            </MenuItem>

            <Divider />

            <MenuItem
              onClick={() => {
                localStorage.getItem("preferredLanguage") == "hi"
                  ? changeLanguage("en")
                  : changeLanguage("hi");
              }}
            >
              <ListItemIcon>
                <img src={trans} width={30} height={30} alt="Translate" />
              </ListItemIcon>
              Translate -- {newLanguage}
            </MenuItem>

            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <img src={settings} width={30} height={30} alt="Settings" />
              </ListItemIcon>
              Settings
            </MenuItem>

            <MenuItem onClick={() => setShowThemeMenu(!showThemeMenu)}>
              <ListItemIcon>
                <img src={ThemeIcon} width={30} height={30} alt="Theme" />
              </ListItemIcon>
              Select Theme
            </MenuItem>

            <MenuItem
              onClick={() => {
                let path = "/help/HelpDesk";
                window.open(path, "_blank");
              }}
            >
              <ListItemIcon>
                <img src={help} width={30} height={30} alt="Help Desk" />
              </ListItemIcon>
              Help Desk
            </MenuItem>

            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <img src={logout} width={30} height={30} alt="Logout" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>

        <Dialog open={showThemeMenu} onClose={handleCloseSelect}>
          <DialogTitle>Select a Theme</DialogTitle>
          <DialogContent>
            <List>
              {themes.map((theme) => (
                <ListItem
                  button
                  key={theme.name}
                  onClick={() => handleThemeChange(theme.name)}
                  selected={selectedTheme === theme.name}
                >
                  {theme.icon}
                  <span style={{ marginLeft: "10px" }}>{theme.name}</span>
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseSelect}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: headerColor1,
            borderBottomRightRadius: "15px",
            height: "30px", // Fixed height in pixels
            padding: "0 15px",
          }}
        >
          <div
            role="presentation"
            onClick={handleClicked}
          >
            <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff" }}>
              <Typography
                sx={{
                  display: "flex",
                  color: "#fff",
                  alignItems: "center",
                }}
              >
                <Link
                  underline="hover"
                  sx={{
                    display: "flex",
                    color: "#fff",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  color="inherit"
                  onClick={handleClickhome}
                >
                  <HomeIcon sx={{ ml: 1, mr: 1 }} fontSize="inherit" />
                  Home
                </Link>
              </Typography>

              {segments.slice(1).map((segment, index) => (
                <Typography
                  key={index}
                  sx={{
                    display: "flex",
                    color: "#fff",
                    alignItems: "center",
                  }}
                >
                  {index > 0 && " / "}
                  {index === segments.length - 2 ? (
                    <span>
                      {segment}
                    </span>
                  ) : (
                    <Link
                      underline="hover"
                      sx={{
                        display: "flex",
                        color: "#fff",
                        alignItems: "center",
                      }}
                      color="inherit"
                      href={`/${segments.slice(0, index + 1).join("/")}`}
                    >
                      {segment}
                    </Link>
                  )}
                </Typography>
              ))}
            </Breadcrumbs>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 15,
              paddingRight: "15px",
            }}
          >
            <p style={{ fontSize: "1.2vw", color: greeting.color }}>
              {greeting.icon} {greeting.text}
            </p>
            <ClockComponent />
          </div>
        </div>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: drawerStyles,
            color: `var(--drawer-color)`,
            overflowX: 'hidden',
            '& .MuiCollapse-root': {
              overflow: 'visible !important'
            }
          },
        }}
      >
        <DrawerHeader>
          <>
            <Stack sx={{ width: "100%", height: "14vh" }} direction="row" justifyContent="center">
              {openlogo ? (
                <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
                  <img src={loged} width={100} height={100} alt="Logo" />
                </div>
              ) : (
                <div style={{ padding: 0 }}></div>
              )}
            </Stack>

            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
            <br />
            <br />
          </>
        </DrawerHeader>

        <br />
        <br />
        <Divider />
        {openlogo && (
          <Paper
            component="form"
            sx={{
              m: "5px 5px",
              p: "0px 2px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Autocomplete
              freeSolo
              fullWidth
              size="small"
              options={items.reduce((acc: any, item: any) => {
                if (item.children) {
                  acc.push(...item.children.map((subItem: any) => subItem.menuName));
                }
                return acc;
              }, [])}
              onChange={handleAutocompleteChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search Menu"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleSearchInputChange}
                />
              )}
            />
          </Paper>
        )}
        <Divider />

        <List sx={{
          overflowY: 'auto',
          overflowX: 'hidden',
          height: 'calc(100vh - 250px)',
          '& .MuiCollapse-root': {
            minHeight: 'unset !important',
            overflow: 'visible !important'
          }
        }}>
          {/* Home List Item with Tooltip - Always shows on hover */}
          <Tooltip
            title="Home"
            placement="right"
            arrow
          >
            <div>
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    routeChangeHome();
                    resetHomeColor();
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 2 : "auto",
                      justifyContent: "center",
                      color: homeColor,
                    }}
                  >
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Home" sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            </div>
          </Tooltip>

          <Divider />

          {/* Dynamic Items List */}
          {items && items.length > 0 ? (
            renderMenu((filteredItems.length > 0) ? filteredItems : items)
          ) : (
            <Typography sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
              No menus available
            </Typography>
          )}
        </List>
      </Drawer>

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box sx={style}>
          <Typography fontWeight={500} fontSize={20} noWrap align="center">
            Node Permission
          </Typography>
          <div>
            <Grid xs={12} item>
              <Box>
                <div style={{ height: "400px", overflow: "auto" }}>
                  <SimpleTreeView expandedItems={expandedItems}>
                    {Array.isArray(treedata)
                      ? treedata.map((node: any) => renderTree(node))
                      : null}
                  </SimpleTreeView>
                </div>
              </Box>
            </Grid>
            <Grid xs={3} item alignItems="center" justifyContent="center">
              <Button
                type="submit"
                fullWidth
                style={{
                  backgroundColor: "#059669",
                  color: "white",
                  marginTop: "10px",
                }}
                onClick={handleSave}
              >
                {t("text.save")}
              </Button>
            </Grid>
          </div>
        </Box>
      </Modal>

      <SwipeableDrawer
        anchor="left"
        open={profileDrawerOpen}
        onClose={() => {
          setProfileDrawerOpen(false);
        }}
        onOpen={() => { }}
        style={{
          zIndex: 1300,
        }}
      >
        <Box sx={{ width: drawerWidth }} role="presentation">
          <IconButton
            edge="end"
            onClick={() => setProfileDrawerOpen(false)}
            aria-label="close"
            sx={{ color: "white", position: "absolute", right: 15, top: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <p
            style={{
              paddingTop: "5vh",
              paddingBottom: "5vh",
              textAlign: "center",
              backgroundImage:
                "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
              color: "whitesmoke",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              fontSize: "20px",
            }}
          >
            User Details
          </p>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                borderRadius: "50%",
                height: "90px",
                width: "90px",
                borderColor:
                  "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
                backgroundColor: "red",
                padding: "13px",
                paddingTop: "30px",
                paddingLeft: "13px",
                color: "whitesmoke",
                fontSize: "20px",
              }}
            >
              {getImageForFirstName(menuData?.userName || '')}
            </div>
          </div>

          <div style={{ marginLeft: "15px" }}>
            {menuData?.userName && menuData.userName.trim() !== "" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <img src={log} width={25} alt="Username" />
                {menuData.userName}
              </div>
            )}
            <br />

            {menuData?.email && menuData.email.trim() !== "" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <img src={emails} width={25} alt="Email" />
                {menuData.email}
              </div>
            )}
            <br />

            {menuData?.phoneNumber && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <img src={call} width={25} alt="Phone" />
                {menuData.phoneNumber}
              </div>
            )}
            <br />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              Account Status :
              {menuData?.emailConfirmed ? (
                <img src={tick} width={25} alt="Active" />
              ) : (
                <img src={crs} width={25} alt="Inactive" />
              )}
            </div>
          </div>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
}

// Export as memoized component to prevent unnecessary re-renders
export default React.memo(MiniDrawer);
























// import * as React from "react";
// import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import CssBaseline from "@mui/material/CssBaseline";
// import Typography from "@mui/material/Typography";
// import Divider from "@mui/material/Divider";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import {
//   Avatar,
//   Checkbox,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Modal,
//   Stack,
// } from "@mui/material";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import call from "../../assets/images/phone-call.png";
// import roles from "../../assets/images/role-model.png";
// import tick from "../../assets/images/check-mark.png";
// import crs from "../../assets/images/cross.png";
// import log from "../../assets/images/profile.png";
// import emails from "../../assets/images/gmail.png";
// import genders from "../../assets/images/symbol.png";
// import dobs from "../../assets/images/timetable.png";
// import id from "../../assets/images/profile1.png";
// import settings from "../../assets/images/settings.png";
// import trans from "../../assets/images/translation.png";
// import logout from "../../assets/images/logout.png";
// import logged from "../../assets/images/permission.png";
// import logo from "../../assets/images/recyclebinLogo.png";
// import help from "../../assets/images/help.png";
// import loged from "../../assets/images/DrawerLogo.png";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";
// import { Home } from "@mui/icons-material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import Collapse from "@mui/material/Collapse";
// import Typewriter from "./TypeWriter";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import FolderIcon from "@mui/icons-material/Folder";
// import TouchAppIcon from "@mui/icons-material/TouchApp";
// import "./Shine.css";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";
// import HomeIcon from "@mui/icons-material/Home";
// import WhatshotIcon from "@mui/icons-material/Whatshot";
// import GrainIcon from "@mui/icons-material/Grain";
// import names from "../../assets/images/id-card (2).png";
// import backgrd from "../../assets/images/backgroundimage.jpg";
// import SearchIcon from "@mui/icons-material/Search";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import Autocomplete from "@mui/material/Autocomplete";
// import InputAdornment from "@mui/material/InputAdornment";
// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
// } from "@mui/material";
// import "./ThemeStyle.css";
// import ThemeIcon from "../../assets/images/themes.png";
// import {
//   Brightness5,
//   Brightness4,
//   Waves,
//   WbSunny,
//   Forest,
//   Flag,
// } from "@mui/icons-material";
// import api from "../../utils/Url";
// import { toast } from "react-toastify";
// import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
// import TreeView from "@mui/x-tree-view/TreeView";
// import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
// import { FaRegFolderOpen } from "react-icons/fa6";
// import DescriptionIcon from '@mui/icons-material/Description';
// import { FaFileLines } from "react-icons/fa6";
// import { Tooltip } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { RootState } from '../../redux/store';
// import { logout as logoutAction } from '../../redux/userSlice';

// const drawerWidth = 225;

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// const openedMixin = (theme: Theme): CSSObject => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme: Theme): CSSObject => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(12)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// interface AppBarProps extends MuiAppBarProps {
//   open?: boolean;
// }

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })<AppBarProps>(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// function getGreeting() {
//   const hour = new Date().getHours();

//   let greeting;
//   if (hour < 12) {
//     greeting = {
//       text: "Good Morning",
//       color: "#FFFFE0",
//       icon: "🌅",
//     };
//   } else if (hour < 17) {
//     greeting = {
//       text: "Good Afternoon",
//       color: "#FFE4B5",
//       icon: "🌞",
//     };
//   } else {
//     greeting = {
//       text: "Good Evening",
//       color: "#FFDAB9",
//       icon: "🌜",
//     };
//   }

//   return greeting;
// }

// interface MenuItem {
//   menuId: number;
//   menuName: string;
//   parentId: number | null;
//   pageUrl: string | null;
//   icon: string | null;
//   displayNo: number | null;
//   isMenu: boolean;
//   isAdd: boolean;
//   isEdit: boolean;
//   isDel: boolean;
//   isView: boolean | null;
//   isPrint: boolean;
//   isExport: boolean;
//   isRelease: boolean;
//   isPost: boolean;
//   vtsCombine: any;
//   hasSubMenu: boolean;
//   children?: MenuItem[];
//   path?: string;
//   permissions?: {
//     isAdd: boolean;
//     isEdit: boolean;
//     isDel: boolean;
//     isView: boolean | null;
//     isPrint: boolean;
//     isExport: boolean;
//     isRelease: boolean;
//     isPost: boolean;
//   };
// }

// interface SidebarProps {
//   items: MenuItem[];
//   onClick?: (e: any, item: any) => void;
// }

// // Separate clock component to prevent re-renders
// const ClockComponent = React.memo(() => {
//   const [date, setDate] = React.useState(new Date());

//   React.useEffect(() => {
//     const timer = setInterval(() => setDate(new Date()), 1000);
//     return () => clearInterval(timer);
//   }, []);

//   const options: Intl.DateTimeFormatOptions = {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   };

//   const formattedDate = date
//     .toLocaleDateString("en-US", options)
//     .split(" ")
//     .map((part, index) =>
//       index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
//     )
//     .join(" ");

//   return (
//     <>
//       <p> Time : {date.toLocaleTimeString()}</p>
//       <p> Date : {formattedDate}</p>
//     </>
//   );
// });

// ClockComponent.displayName = 'ClockComponent';

// function MiniDrawer({ items, onClick }: SidebarProps) {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [open, setOpen] = React.useState(true);
//   const [menuOpen, setMenuOpen] = React.useState(false);
//   const [profileDrawerOpen, setProfileDrawerOpen] = React.useState(false);
//   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
//   const [collapseIndex, setCollapseIndex] = React.useState<any>(-1);
//   const [openlogo, setOpenlogo] = React.useState(true);
//   const [homeColor, setHomeColor] = React.useState("inherit");
//   const { t } = useTranslation();

//   const [selectedSubMenu, setSelectedSubMenu] = React.useState(null);
//   const [expandedItems, setExpandedItems] = React.useState<any[]>([]);
//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [treedata, setTreedata] = React.useState<any>([]);
//   const [check, setCheck] = React.useState<any>([]);
//   const [searchValue, setSearchValue] = React.useState("");
//   const [filteredItems, setFilteredItems] = React.useState<MenuItem[]>([]);
//   const [activeMenu, setActiveMenu] = React.useState<number | null>(null);

//   // Use state for open menus to trigger re-renders
//   const [openMenus, setOpenMenus] = React.useState<Set<number>>(new Set());

//   const themes = [
//     { name: "light-theme", icon: <Brightness5 /> },
//     { name: "dark-theme", icon: <Brightness4 /> },
//     { name: "ocean-theme", icon: <Waves /> },
//     { name: "sunset-theme", icon: <WbSunny /> },
//     { name: "forest-theme", icon: <Forest /> },
//     { name: "bhagwa-theme", icon: <Flag /> },
//   ];

//   // Get user details from Redux store
//   const userDetails = useSelector((state: RootState) => state.user.userDetails);
//   const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);

//   // Get user data safely
//   const getUserData = () => {
//     if (userDetails) {
//       return userDetails;
//     }

//     // Fallback to localStorage
//     try {
//       const storedUserDetails = localStorage.getItem('userDetails');
//       if (storedUserDetails) {
//         return JSON.parse(storedUserDetails);
//       }
//     } catch (error) {
//       console.error('Error parsing user details from localStorage:', error);
//     }

//     return null;
//   };

//   const menuData = getUserData();

//   const greeting = getGreeting();

//   // Function definitions that were missing
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleSave = () => {
//     toast.success("Save functionality");
//     handleCloseModal();
//   };

//   const renderTree = (nodes: any) => (
//     <TreeItem
//       key={nodes.id}
//       itemId={String(nodes.id)}
//       label={
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <Checkbox
//             checked={check.indexOf(nodes.id) !== -1}
//             onChange={() => { }}
//             onClick={(event: any) => event.stopPropagation()}
//           />
//           <div style={{ marginLeft: 8 }}>{nodes.name}</div>
//         </div>
//       }
//       onClick={() => { }}
//     >
//       {Array.isArray(nodes.childnode)
//         ? nodes.childnode.map((node: any) => renderTree(node))
//         : null}
//     </TreeItem>
//   );

//   // Other existing function definitions
//   function searchMenuItems(items: any, query: string) {
//     const results = [];

//     for (const menuItem of items) {
//       if (menuItem.menuName?.toLowerCase().includes(query.toLowerCase())) {
//         results.push(menuItem);
//       } else if (menuItem.children && menuItem.children.length > 0) {
//         const matchingSubItems = menuItem.children.filter(
//           (subItem: { menuName: string }) =>
//             subItem.menuName?.toLowerCase().includes(query.toLowerCase())
//         );
//         if (matchingSubItems.length > 0) {
//           results.push({ ...menuItem, children: matchingSubItems });
//         }
//       }
//     }
//     return results;
//   }

//   const handleSearchIconClick = () => {
//     const filtered = searchMenuItems(items, searchValue);
//     setFilteredItems(filtered);
//   };

//   const handleNavigation = (path: any) => {
//     navigate(path);
//   };

//   const handleAutocompleteChange = (event: any, value: any) => {
//     const selectedItem = items.find((item: any) =>
//       item.children?.some((subItem: any) => subItem.menuName === value)
//     );
//     if (selectedItem) {
//       const selectedSubItem = selectedItem.children.find(
//         (subItem: any) => subItem.menuName === value
//       );
//       if (selectedSubItem) {
//         handleNavigation(selectedSubItem.path);
//       }
//     }
//   };

//   const allMenuNames = items.reduce((acc: any, item: { children: any[] }) => {
//     if (item.children) {
//       return [
//         ...acc,
//         ...item.children.map((subItem: { menuName: any }) => subItem.menuName),
//       ];
//     }
//     return acc;
//   }, []);

//   const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value.toLowerCase();
//     setSearchValue(value);

//     const expandedMenuIds: any = new Set();

//     if (value === "") {
//       setFilteredItems(items);
//       setOpenMenus(new Set());
//       return;
//     }

//     const filtered = items.reduce((acc: any, menu: any) => {
//       if (menu.menuName?.toLowerCase().includes(value)) {
//         acc.push(menu);
//         expandedMenuIds.add(menu.menuId);
//       } else if (menu.children) {
//         const filteredChildren = menu.children.filter((child: any) =>
//           child.menuName?.toLowerCase().includes(value)
//         );

//         if (filteredChildren.length > 0) {
//           acc.push({ ...menu, children: filteredChildren });
//           expandedMenuIds.add(menu.menuId);
//         }
//       }
//       return acc;
//     }, []);

//     setFilteredItems(filtered);
//     setOpenMenus(expandedMenuIds);
//   };

//   var [date, setDate] = React.useState(new Date());

//   const options: Intl.DateTimeFormatOptions = {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   };

//   const formattedDate = date
//     .toLocaleDateString("en-US", options)
//     .split(" ")
//     .map((part, index) =>
//       index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
//     )
//     .join(" ");

//   React.useEffect(() => {
//     var timer = setInterval(() => setDate(new Date()), 1000);
//     return function cleanup() {
//       clearInterval(timer);
//     };
//   });

//   const resetHomeColor = () => {
//     setHomeColor("#FF0000");
//   };

//   // FIXED: Updated handleMenuClick function
//   const handleMenuClick = (menu: any, e?: React.MouseEvent) => {
//     if (e) {
//       e.preventDefault();
//       e.stopPropagation();
//     }

//     console.log('=== MENU CLICK START ===');
//     console.log('Menu clicked:', menu.menuName, 'ID:', menu.menuId);
//     console.log('Has children:', menu.children?.length > 0);
//     console.log('Current open menus:', Array.from(openMenus));

//     // Update active menu
//     setActiveMenu(menu.menuId);

//     if (menu.children && menu.children.length > 0) {
//       // This is a folder - toggle expand/collapse
//       console.log('Toggling folder:', menu.menuName);

//       // Toggle the menu
//       setOpenMenus(prev => {
//         const newOpenMenus = new Set(prev);
//         if (newOpenMenus.has(menu.menuId)) {
//           newOpenMenus.delete(menu.menuId);
//           console.log('Closing menu:', menu.menuId);
//         } else {
//           // If it's a top-level menu (parentId === null), close other top-level menus
//           if (menu.parentId === null) {
//             // Only close other top-level menus
//             const otherTopLevelMenus = Array.from(newOpenMenus).filter(id => {
//               const menuItem = findMenuItem(items, id);
//               return menuItem && menuItem.parentId === null && id !== menu.menuId;
//             });
//             otherTopLevelMenus.forEach(id => newOpenMenus.delete(id));
//           }
//           newOpenMenus.add(menu.menuId);
//           console.log('Opening menu:', menu.menuId);
//         }

//         console.log('New open menus:', Array.from(newOpenMenus));
//         return newOpenMenus;
//       });

//       // Store permissions for this menu item even though we're not navigating
//       const testPermissions = {
//         isAdd: true,
//         isEdit: true,
//         isDel: true,
//         isView: true,
//         isPrint: true,
//         isExport: true,
//         isRelease: true,
//         isPost: true
//       };

//       sessionStorage.setItem("menuId", menu.menuId.toString());
//       sessionStorage.setItem("menuName", menu.menuName);
//       sessionStorage.setItem("menuPermissions", JSON.stringify(testPermissions));

//       // If onClick prop is provided, call it after handling the toggle
//       if (onClick) {
//         onClick(e || null, menu);
//       }
//     } else {
//       // This is a leaf node - navigate
//       console.log('Navigating to leaf node');

//       sessionStorage.setItem("menuId", menu.menuId.toString());
//       sessionStorage.setItem("menuName", menu.menuName);
//       sessionStorage.setItem("menuPermissions", JSON.stringify(menu.permissions || {}));

//       // If onClick prop is provided, use it
//       if (onClick) {
//         onClick(e || null, menu);
//       } else {
//         // Fallback navigation
//         const path = menu.path || `/${menu.menuName?.replace(/\s+/g, "").toLowerCase()}`;
//         navigate(`${path}?appId=${menu.menuId}&Appname=${menu.menuName}.aspx`);
//       }
//     }

//     console.log('=== MENU CLICK END ===');
//   };

//   // Helper function to find a menu item by ID
//   const findMenuItem = (menuList: any[], id: number): any => {
//     for (const item of menuList) {
//       if (item.menuId === id) return item;
//       if (item.children) {
//         const found = findMenuItem(item.children, id);
//         if (found) return found;
//       }
//     }
//     return null;
//   };

//   // FIXED: renderMenu function with proper isOpen check
//   const renderMenu = (menus: any[], level = 0) => {
//     if (!menus || menus.length === 0) {
//       return (
//         <Typography sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
//           No menus available
//         </Typography>
//       );
//     }

//     return menus.map((menu: any) => {
//       const hasChildren = menu.children && menu.children.length > 0;
//       const isOpen = openMenus.has(menu.menuId);

//       return (
//         <React.Fragment key={`${menu.menuId}-${level}`}>
//           <ListItem
//             disablePadding
//             sx={{
//               display: "block",
//               backgroundColor: activeMenu === menu.menuId ? "#dfe6f5" : "inherit",
//               "&:hover": { backgroundColor: "#f8f9fa" },
//               borderRadius: "6px",
//               transition: "background 0.2s ease-in-out",
//               marginBottom: "2px",
//             }}
//           >
//             <ListItemButton
//               sx={{
//                 minHeight: 48,
//                 justifyContent: open ? "initial" : "center",
//                 px: 2.5,
//                 pl: level * 2 + (open ? 2.5 : 1.5),
//               }}
//               onClick={(e) => handleMenuClick(menu, e)}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 0,
//                   mr: open ? 2 : "auto",
//                   justifyContent: "center",
//                   color: activeMenu === menu.menuId ? "#FF0000" : "#333",
//                 }}
//               >
//                 {hasChildren ? (
//                   isOpen ? (
//                     <FaRegFolderOpen style={{ color: "#42AEEE", fontSize: "18px" }} />
//                   ) : (
//                     <FolderIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//                   )
//                 ) : (
//                   <DescriptionIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//                 )}
//               </ListItemIcon>

//               <ListItemText
//                 primary={menu.menuName || 'Unnamed Menu'}
//                 sx={{
//                   opacity: open ? 1 : 0,
//                   fontWeight: "bold",
//                   fontSize: "13px",
//                   color: activeMenu === menu.menuId ? "#0056b3" : "#333",
//                   "& .MuiListItemText-primary": {
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }
//                 }}
//               />

//               {hasChildren && open && (
//                 <Box sx={{ ml: 1 }}>
//                   {isOpen ? (
//                     <ExpandLessIcon fontSize="small" style={{ color: "#42AEEE" }} />
//                   ) : (
//                     <ExpandMoreIcon fontSize="small" style={{ color: "#42AEEE" }} />
//                   )}
//                 </Box>
//               )}
//             </ListItemButton>
//           </ListItem>

//           {/* Render children if menu is open */}
//           {hasChildren && isOpen && (
//             <Collapse
//               in={isOpen}
//               timeout="auto"
//               unmountOnExit
//               sx={{ pl: 2 }}
//             >
//               <List component="div" disablePadding>
//                 {renderMenu(menu.children, level + 1)}
//               </List>
//             </Collapse>
//           )}
//         </React.Fragment>
//       );
//     });
//   };

//   const handleClick = (event: any) => {
//     setAnchorEl(event.currentTarget);
//     setMenuOpen(true);
//     setHomeColor("inherit");
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setMenuOpen(false);
//   };

//   const routeChangeHome = () => {
//     navigate(`/home`);
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//     setOpenlogo(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//     setOpenlogo(false);
//   };

//   const handleLogout = () => {
//     dispatch(logoutAction());
//     sessionStorage.clear();
//     navigate("/");
//   };

//   const { i18n } = useTranslation();

//   const changeLanguage = (language: any) => {
//     i18n.changeLanguage(language);
//     localStorage.setItem("preferredLanguage", language);
//   };

//   var currentLanguage = localStorage.getItem("preferredLanguage");
//   var newLanguage = currentLanguage === "hi" ? "English" : "हिंदी";

//   const collapsehamndle = (index: any) => {
//     if (index == collapseIndex) {
//       setCollapseIndex(-1);
//     } else {
//       setCollapseIndex(index);
//     }
//   };

//   const getImageForFirstName = (userName: string) => {
//     const firstLetter = userName ? userName.charAt(0).toUpperCase() : "";
//     return `${firstLetter}`;
//   };

//   const getGenderText = (gendeR_ID: any) => {
//     switch (gendeR_ID) {
//       case 1:
//         return "Male";
//       case 2:
//         return "Female";
//       case 3:
//         return "Other";
//       default:
//         return "Unknown";
//     }
//   };

//   const handleMyProfileClick = () => {
//     setProfileDrawerOpen(!profileDrawerOpen);
//   };

//   const currentPathname = window.location.pathname;
//   const segments = currentPathname.split("/").filter(Boolean);

//   function handleClicked(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//     event.preventDefault();
//   }

//   const handleClickhome = () => {
//     navigate(`/home`);
//   };

//   const handleRightClick = (path: any) => (e: any) => {
//     e.preventDefault();
//     window.open(path, "_blank");
//   };

//   const [showThemeMenu, setShowThemeMenu] = React.useState(false);
//   const [selectedTheme, setSelectedTheme] = React.useState(() => {
//     const storedTheme = localStorage.getItem("theme");
//     return storedTheme ? storedTheme : themes[0]["name"];
//   });

//   React.useEffect(() => {
//     document.body.className = selectedTheme;
//     localStorage.setItem("theme", selectedTheme);
//   }, [selectedTheme]);

//   const handleThemeChange = (theme: any) => {
//     setSelectedTheme(theme);
//     setShowThemeMenu(false);
//   };

//   const handleCloseSelect = () => {
//     setShowThemeMenu(false);
//   };

//   const headerColor1 = `var(--header-background)`;
//   const drawerStyles = `var(--drawer-background)`;

//   // Don't render the sidebar if user is not authenticated
//   if (!isAuthenticated) {
//     return null;
//   }

//   return (
//     <Box sx={{ display: "flex" }}>
//       <AppBar position="fixed" open={open} style={{}}>
//         <Toolbar
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             background: `var(--header-background1)`,
//             color: `var(--header-color1)`,
//             borderBottom: "1px solid",
//             borderImage: "linear-gradient(to right,rgb(240, 123, 6), #FFFFFF,rgb(30, 239, 11)) 1",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-start",
//               alignItems: "center",
//             }}
//           >
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               onClick={handleDrawerOpen}
//               edge="start"
//               sx={{
//                 ...(open && { display: "none" }),
//               }}
//             >
//               <MenuIcon fontSize="large" />
//             </IconButton>

//             {!openlogo && <img src={logo} width={60} height={60} alt="Logo" />}
//           </div>

//           <div style={{ fontFamily: "Georgia, serif" }}>
//             <span style={{ fontSize: "3vw", color: "#FF671F" }}>V</span>
//             <span style={{ fontSize: "2.2vw" }}>ehicle </span>
//             <span style={{ fontSize: "3vw", color: "#D50E00" }}>T</span>
//             <span style={{ fontSize: "2.2vw" }}>racking </span>
//             <span style={{ fontSize: "3vw", color: "#FFE100" }}>S</span>
//             <span style={{ fontSize: "2.2vw" }}>ystem</span>
//           </div>

//           <IconButton
//             onClick={handleClick}
//             size="small"
//             sx={{ ml: 2 }}
//             aria-controls={open ? "account-menu" : undefined}
//             aria-haspopup="true"
//             aria-expanded={open ? "true" : undefined}
//           >
//             <Avatar sx={{ width: 40, height: 40 }}>
//               {menuData?.userName ? menuData.userName[0].toUpperCase() : 'U'}
//             </Avatar>
//           </IconButton>

//           <Menu
//             anchorEl={anchorEl}
//             id="account-menu"
//             open={menuOpen}
//             onClick={handleClose}
//             PaperProps={{
//               elevation: 0,
//               sx: {
//                 backgroundColor: `var(--menu-background)`,
//                 color: `var(--menu-color)`,
//                 overflow: "auto",
//                 filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//                 paddingRight: "10px",
//                 paddingLeft: "10px",
//                 mt: 1.5,
//                 "& .MuiAvatar-root": {
//                   width: 32,
//                   height: 32,
//                   ml: -0.5,
//                   mr: 1,
//                 },
//                 "&::before": {
//                   content: '""',
//                   display: "block",
//                   position: "absolute",
//                   top: 0,
//                   right: 14,
//                   width: 10,
//                   height: 10,
//                   bgcolor: "background.paper",
//                   transform: "translateY(-50%) rotate(45deg)",
//                   zIndex: 0,
//                 },
//               },
//             }}
//             transformOrigin={{ horizontal: "right", vertical: "top" }}
//             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//           >
//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={logged} width={40} height={40} alt="User" />
//               </ListItemIcon>
//               {menuData?.userName || "User"}
//             </MenuItem>

//             <MenuItem onClick={handleMyProfileClick}>
//               <ListItemIcon>
//                 <img src={id} width={30} height={30} alt="Profile" />
//               </ListItemIcon>
//               My Profile
//             </MenuItem>

//             <Divider />

//             <MenuItem
//               onClick={() => {
//                 localStorage.getItem("preferredLanguage") == "hi"
//                   ? changeLanguage("en")
//                   : changeLanguage("hi");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={trans} width={30} height={30} alt="Translate" />
//               </ListItemIcon>
//               Translate -- {newLanguage}
//             </MenuItem>

//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={settings} width={30} height={30} alt="Settings" />
//               </ListItemIcon>
//               Settings
//             </MenuItem>

//             <MenuItem onClick={() => setShowThemeMenu(!showThemeMenu)}>
//               <ListItemIcon>
//                 <img src={ThemeIcon} width={30} height={30} alt="Theme" />
//               </ListItemIcon>
//               Select Theme
//             </MenuItem>

//             <MenuItem
//               onClick={() => {
//                 let path = "/help/HelpDesk";
//                 window.open(path, "_blank");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={help} width={30} height={30} alt="Help Desk" />
//               </ListItemIcon>
//               Help Desk
//             </MenuItem>

//             <Divider />
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <img src={logout} width={30} height={30} alt="Logout" />
//               </ListItemIcon>
//               Logout
//             </MenuItem>
//           </Menu>
//         </Toolbar>

//         <Dialog open={showThemeMenu} onClose={handleCloseSelect}>
//           <DialogTitle>Select a Theme</DialogTitle>
//           <DialogContent>
//             <List>
//               {themes.map((theme) => (
//                 <ListItem
//                   button
//                   key={theme.name}
//                   onClick={() => handleThemeChange(theme.name)}
//                   selected={selectedTheme === theme.name}
//                 >
//                   {theme.icon}
//                   <span style={{ marginLeft: "10px" }}>{theme.name}</span>
//                 </ListItem>
//               ))}
//             </List>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseSelect}>Cancel</Button>
//           </DialogActions>
//         </Dialog>

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: headerColor1,
//             borderBottomRightRadius: "15px",
//             height: "30px", // Fixed height in pixels
//             padding: "0 15px",
//           }}
//         >
//           <div
//             role="presentation"
//             onClick={handleClicked}
//           >
//             <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff" }}>
//               <Typography
//                 sx={{
//                   display: "flex",
//                   color: "#fff",
//                   alignItems: "center",
//                 }}
//               >
//                 <Link
//                   underline="hover"
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                     cursor: "pointer",
//                   }}
//                   color="inherit"
//                   onClick={handleClickhome}
//                 >
//                   <HomeIcon sx={{ ml: 1, mr: 1 }} fontSize="inherit" />
//                   Home
//                 </Link>
//               </Typography>

//               {segments.slice(1).map((segment, index) => (
//                 <Typography
//                   key={index}
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                   }}
//                 >
//                   {index > 0 && " / "}
//                   {index === segments.length - 2 ? (
//                     <span>
//                       {segment}
//                     </span>
//                   ) : (
//                     <Link
//                       underline="hover"
//                       sx={{
//                         display: "flex",
//                         color: "#fff",
//                         alignItems: "center",
//                       }}
//                       color="inherit"
//                       href={`/${segments.slice(0, index + 1).join("/")}`}
//                     >
//                       {segment}
//                     </Link>
//                   )}
//                 </Typography>
//               ))}
//             </Breadcrumbs>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               gap: 15,
//               paddingRight: "15px",
//             }}
//           >
//             <p style={{ fontSize: "1.2vw", color: greeting.color }}>
//               {greeting.icon} {greeting.text}
//             </p>
//             <ClockComponent />
//           </div>
//         </div>
//       </AppBar>

//       <Drawer
//         variant="permanent"
//         open={open}
//         PaperProps={{
//           sx: {
//             backgroundColor: drawerStyles,
//             color: `var(--drawer-color)`,
//             overflowX: 'hidden',
//             '& .MuiCollapse-root': {
//               overflow: 'visible !important'
//             }
//           },
//         }}
//       >
//         <DrawerHeader>
//           <>
//             <Stack sx={{ width: "100%", height: "14vh" }} direction="row" justifyContent="center">
//               {openlogo ? (
//                 <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
//                   <img src={loged} width={100} height={100} alt="Logo" />
//                 </div>
//               ) : (
//                 <div style={{ padding: 0 }}></div>
//               )}
//             </Stack>

//             <IconButton onClick={handleDrawerClose}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//             <br />
//             <br />
//           </>
//         </DrawerHeader>

//         <br />
//         <br />
//         <Divider />
//         {openlogo && (
//           <Paper
//             component="form"
//             sx={{
//               m: "5px 5px",
//               p: "0px 2px",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <Autocomplete
//               freeSolo
//               fullWidth
//               size="small"
//               options={items.reduce((acc: any, item: any) => {
//                 if (item.children) {
//                   acc.push(...item.children.map((subItem: any) => subItem.menuName));
//                 }
//                 return acc;
//               }, [])}
//               onChange={handleAutocompleteChange}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   placeholder="Search Menu"
//                   variant="outlined"
//                   InputProps={{
//                     ...params.InputProps,
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={handleSearchInputChange}
//                 />
//               )}
//             />
//           </Paper>
//         )}
//         <Divider />

//         <List sx={{
//           overflowY: 'auto',
//           overflowX: 'hidden',
//           height: 'calc(100vh - 250px)',
//           '& .MuiCollapse-root': {
//             minHeight: 'unset !important',
//             overflow: 'visible !important'
//           }
//         }}>
//           {/* Home List */}
//           <ListItem disablePadding>
//             <ListItemButton
//               sx={{
//                 minHeight: 48,
//                 justifyContent: open ? "initial" : "center",
//                 px: 2.5,
//               }}
//               onClick={() => {
//                 routeChangeHome();
//                 resetHomeColor();
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 0,
//                   mr: open ? 2 : "auto",
//                   justifyContent: "center",
//                   color: homeColor,
//                 }}
//               >
//                 <HomeIcon />
//               </ListItemIcon>
//               <ListItemText primary="Home" sx={{ opacity: open ? 1 : 0 }} />
//             </ListItemButton>
//           </ListItem>

//           <Divider />

//           {/* Dynamic Items List */}
//           {items && items.length > 0 ? (
//             renderMenu((filteredItems.length > 0) ? filteredItems : items)
//           ) : (
//             <Typography sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
//               No menus available
//             </Typography>
//           )}
//         </List>
//       </Drawer>

//       <Modal open={isModalOpen} onClose={handleCloseModal}>
//         <Box sx={style}>
//           <Typography fontWeight={500} fontSize={20} noWrap align="center">
//             Node Permission
//           </Typography>
//           <div>
//             <Grid xs={12} item>
//               <Box>
//                 <div style={{ height: "400px", overflow: "auto" }}>
//                   <SimpleTreeView expandedItems={expandedItems}>
//                     {Array.isArray(treedata)
//                       ? treedata.map((node: any) => renderTree(node))
//                       : null}
//                   </SimpleTreeView>
//                 </div>
//               </Box>
//             </Grid>
//             <Grid xs={3} item alignItems="center" justifyContent="center">
//               <Button
//                 type="submit"
//                 fullWidth
//                 style={{
//                   backgroundColor: "#059669",
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 onClick={handleSave}
//               >
//                 {t("text.save")}
//               </Button>
//             </Grid>
//           </div>
//         </Box>
//       </Modal>

//       <SwipeableDrawer
//         anchor="left"
//         open={profileDrawerOpen}
//         onClose={() => {
//           setProfileDrawerOpen(false);
//         }}
//         onOpen={() => { }}
//         style={{
//           zIndex: 1300,
//         }}
//       >
//         <Box sx={{ width: drawerWidth }} role="presentation">
//           <IconButton
//             edge="end"
//             onClick={() => setProfileDrawerOpen(false)}
//             aria-label="close"
//             sx={{ color: "white", position: "absolute", right: 15, top: 2 }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <p
//             style={{
//               paddingTop: "5vh",
//               paddingBottom: "5vh",
//               textAlign: "center",
//               backgroundImage:
//                 "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//               color: "whitesmoke",
//               borderBottomLeftRadius: "10px",
//               borderBottomRightRadius: "10px",
//               fontSize: "20px",
//             }}
//           >
//             User Details
//           </p>

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginTop: "10px",
//               marginBottom: "10px",
//             }}
//           >
//             <div
//               style={{
//                 textAlign: "center",
//                 borderRadius: "50%",
//                 height: "90px",
//                 width: "90px",
//                 borderColor:
//                   "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//                 backgroundColor: "red",
//                 padding: "13px",
//                 paddingTop: "30px",
//                 paddingLeft: "13px",
//                 color: "whitesmoke",
//                 fontSize: "20px",
//               }}
//             >
//               {getImageForFirstName(menuData?.userName || '')}
//             </div>
//           </div>

//           <div style={{ marginLeft: "15px" }}>
//             {menuData?.userName && menuData.userName.trim() !== "" && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={log} width={25} alt="Username" />
//                 {menuData.userName}
//               </div>
//             )}
//             <br />

//             {menuData?.email && menuData.email.trim() !== "" && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={emails} width={25} alt="Email" />
//                 {menuData.email}
//               </div>
//             )}
//             <br />

//             {menuData?.phoneNumber && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={call} width={25} alt="Phone" />
//                 {menuData.phoneNumber}
//               </div>
//             )}
//             <br />

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//               }}
//             >
//               Account Status :
//               {menuData?.emailConfirmed ? (
//                 <img src={tick} width={25} alt="Active" />
//               ) : (
//                 <img src={crs} width={25} alt="Inactive" />
//               )}
//             </div>
//           </div>
//         </Box>
//       </SwipeableDrawer>
//     </Box>
//   );
// }

// // Export as memoized component to prevent unnecessary re-renders
// export default React.memo(MiniDrawer);





































// import * as React from "react";
// import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import CssBaseline from "@mui/material/CssBaseline";
// import Typography from "@mui/material/Typography";
// import Divider from "@mui/material/Divider";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import {
//   Avatar,
//   Checkbox,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Modal,
//   Stack,
// } from "@mui/material";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import call from "../../assets/images/phone-call.png";
// import roles from "../../assets/images/role-model.png";
// import tick from "../../assets/images/check-mark.png";
// import crs from "../../assets/images/cross.png";
// import log from "../../assets/images/profile.png";
// import emails from "../../assets/images/gmail.png";
// import genders from "../../assets/images/symbol.png";
// import dobs from "../../assets/images/timetable.png";
// import id from "../../assets/images/profile1.png";
// import settings from "../../assets/images/settings.png";
// import trans from "../../assets/images/translation.png";
// import logout from "../../assets/images/logout.png";
// import logged from "../../assets/images/permission.png";
// import logo from "../../assets/images/recyclebinLogo.png";
// import help from "../../assets/images/help.png";
// import loged from "../../assets/images/DrawerLogo.png";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";
// import { Home } from "@mui/icons-material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import Collapse from "@mui/material/Collapse";
// import Typewriter from "./TypeWriter";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import FolderIcon from "@mui/icons-material/Folder";
// import TouchAppIcon from "@mui/icons-material/TouchApp";
// import "./Shine.css";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";
// import HomeIcon from "@mui/icons-material/Home";
// import WhatshotIcon from "@mui/icons-material/Whatshot";
// import GrainIcon from "@mui/icons-material/Grain";
// import names from "../../assets/images/id-card (2).png";
// import backgrd from "../../assets/images/backgroundimage.jpg";
// import SearchIcon from "@mui/icons-material/Search";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import Autocomplete from "@mui/material/Autocomplete";
// import InputAdornment from "@mui/material/InputAdornment";
// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
// } from "@mui/material";
// import "./ThemeStyle.css";
// import ThemeIcon from "../../assets/images/themes.png";
// import {
//   Brightness5,
//   Brightness4,
//   Waves,
//   WbSunny,
//   Forest,
//   Flag,
// } from "@mui/icons-material";
// import api from "../../utils/Url";
// import { toast } from "react-toastify";
// import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
// import TreeView from "@mui/x-tree-view/TreeView";
// import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
// import { FaRegFolderOpen } from "react-icons/fa6";
// import DescriptionIcon from '@mui/icons-material/Description';
// import { FaFileLines } from "react-icons/fa6";
// import { Tooltip } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { RootState } from '../../redux/store';
// import { logout as logoutAction } from '../../redux/userSlice';

// const drawerWidth = 225;

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// const openedMixin = (theme: Theme): CSSObject => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme: Theme): CSSObject => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(12)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// interface AppBarProps extends MuiAppBarProps {
//   open?: boolean;
// }

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })<AppBarProps>(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// function getGreeting() {
//   const hour = new Date().getHours();

//   let greeting;
//   if (hour < 12) {
//     greeting = {
//       text: "Good Morning",
//       color: "#FFFFE0",
//       icon: "🌅",
//     };
//   } else if (hour < 17) {
//     greeting = {
//       text: "Good Afternoon",
//       color: "#FFE4B5",
//       icon: "🌞",
//     };
//   } else {
//     greeting = {
//       text: "Good Evening",
//       color: "#FFDAB9",
//       icon: "🌜",
//     };
//   }

//   return greeting;
// }

// interface MenuItem {
//   menuId: number;
//   menuName: string;
//   parentId: number | null;
//   pageUrl: string | null;
//   icon: string | null;
//   displayNo: number | null;
//   isMenu: boolean;
//   isAdd: boolean;
//   isEdit: boolean;
//   isDel: boolean;
//   isView: boolean | null;
//   isPrint: boolean;
//   isExport: boolean;
//   isRelease: boolean;
//   isPost: boolean;
//   vtsCombine: any;
//   hasSubMenu: boolean;
//   children?: MenuItem[];
//   path?: string;
//   permissions?: {
//     isAdd: boolean;
//     isEdit: boolean;
//     isDel: boolean;
//     isView: boolean | null;
//     isPrint: boolean;
//     isExport: boolean;
//     isRelease: boolean;
//     isPost: boolean;
//   };
// }

// interface SidebarProps {
//   items: MenuItem[];
//   onClick?: (e: any, item: any) => void;
// }

// export default function MiniDrawer({ items, onClick }: SidebarProps) {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);
//   const [menuOpen, setMenuOpen] = React.useState(false);
//   const [profileDrawerOpen, setProfileDrawerOpen] = React.useState(false);
//   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
//   const [collapseIndex, setCollapseIndex] = React.useState<any>(-1);
//   const [openlogo, setOpenlogo] = React.useState(true);
//   const [homeColor, setHomeColor] = React.useState("inherit");
//   const { t } = useTranslation();

//   const [selectedSubMenu, setSelectedSubMenu] = React.useState(null);
//   const [expandedItems, setExpandedItems] = React.useState<any[]>([]);
//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [treedata, setTreedata] = React.useState<any>([]);
//   const [check, setCheck] = React.useState<any>([]);
//   const [searchValue, setSearchValue] = React.useState("");
//   const [filteredItems, setFilteredItems] = React.useState<MenuItem[]>([]);
//   const [activeMenu, setActiveMenu] = React.useState<number | null>(null);
//   const [openMenus, setOpenMenus] = React.useState<Set<number>>(new Set());

//   const themes = [
//     { name: "light-theme", icon: <Brightness5 /> },
//     { name: "dark-theme", icon: <Brightness4 /> },
//     { name: "ocean-theme", icon: <Waves /> },
//     { name: "sunset-theme", icon: <WbSunny /> },
//     { name: "forest-theme", icon: <Forest /> },
//     { name: "bhagwa-theme", icon: <Flag /> },
//   ];

//   // Get user details from Redux store
//   const userDetails = useSelector((state: RootState) => state.user.userDetails);
//   const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);

//   // Get user data safely
//   const getUserData = () => {
//     if (userDetails) {
//       return userDetails;
//     }

//     // Fallback to localStorage
//     try {
//       const storedUserDetails = localStorage.getItem('userDetails');
//       if (storedUserDetails) {
//         return JSON.parse(storedUserDetails);
//       }
//     } catch (error) {
//       console.error('Error parsing user details from localStorage:', error);
//     }

//     return null;
//   };

//   const menuData = getUserData();

//   const greeting = getGreeting();

//   let navigate = useNavigate();

//   // Function definitions that were missing
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleSave = () => {
//     toast.success("Save functionality");
//     handleCloseModal();
//   };

//   const renderTree = (nodes: any) => (
//     <TreeItem
//       key={nodes.id}
//       itemId={String(nodes.id)}
//       label={
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <Checkbox
//             checked={check.indexOf(nodes.id) !== -1}
//             onChange={() => { }}
//             onClick={(event: any) => event.stopPropagation()}
//           />
//           <div style={{ marginLeft: 8 }}>{nodes.name}</div>
//         </div>
//       }
//       onClick={() => { }}
//     >
//       {Array.isArray(nodes.childnode)
//         ? nodes.childnode.map((node: any) => renderTree(node))
//         : null}
//     </TreeItem>
//   );

//   // Other existing function definitions
//   function searchMenuItems(items: any, query: string) {
//     const results = [];

//     for (const menuItem of items) {
//       if (menuItem.menuName?.toLowerCase().includes(query.toLowerCase())) {
//         results.push(menuItem);
//       } else if (menuItem.children && menuItem.children.length > 0) {
//         const matchingSubItems = menuItem.children.filter(
//           (subItem: { menuName: string }) =>
//             subItem.menuName?.toLowerCase().includes(query.toLowerCase())
//         );
//         if (matchingSubItems.length > 0) {
//           results.push({ ...menuItem, children: matchingSubItems });
//         }
//       }
//     }
//     return results;
//   }

//   const handleSearchIconClick = () => {
//     const filtered = searchMenuItems(items, searchValue);
//     setFilteredItems(filtered);
//   };

//   const handleNavigation = (path: any) => {
//     navigate(path);
//   };

//   const handleAutocompleteChange = (event: any, value: any) => {
//     const selectedItem = items.find((item: any) =>
//       item.children?.some((subItem: any) => subItem.menuName === value)
//     );
//     if (selectedItem) {
//       const selectedSubItem = selectedItem.children.find(
//         (subItem: any) => subItem.menuName === value
//       );
//       if (selectedSubItem) {
//         handleNavigation(selectedSubItem.path);
//       }
//     }
//   };

//   const allMenuNames = items.reduce((acc: any, item: { children: any[] }) => {
//     if (item.children) {
//       return [
//         ...acc,
//         ...item.children.map((subItem: { menuName: any }) => subItem.menuName),
//       ];
//     }
//     return acc;
//   }, []);

//   const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value.toLowerCase();
//     setSearchValue(value);

//     const expandedMenuIds: any = new Set();

//     if (value === "") {
//       setFilteredItems(items);
//       setOpenMenus(new Set());
//       return;
//     }

//     const filtered = items.reduce((acc: any, menu: any) => {
//       if (menu.menuName?.toLowerCase().includes(value)) {
//         acc.push(menu);
//         expandedMenuIds.add(menu.menuId);
//       } else if (menu.children) {
//         const filteredChildren = menu.children.filter((child: any) =>
//           child.menuName?.toLowerCase().includes(value)
//         );

//         if (filteredChildren.length > 0) {
//           acc.push({ ...menu, children: filteredChildren });
//           expandedMenuIds.add(menu.menuId);
//         }
//       }
//       return acc;
//     }, []);

//     setFilteredItems(filtered);
//     setOpenMenus(expandedMenuIds);
//   };

//   var [date, setDate] = React.useState(new Date());

//   const options: Intl.DateTimeFormatOptions = {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   };

//   const formattedDate = date
//     .toLocaleDateString("en-US", options)
//     .split(" ")
//     .map((part, index) =>
//       index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
//     )
//     .join(" ");

//   React.useEffect(() => {
//     var timer = setInterval(() => setDate(new Date()), 1000);
//     return function cleanup() {
//       clearInterval(timer);
//     };
//   });

//   const resetHomeColor = () => {
//     setHomeColor("#FF0000");
//   };

//   const handleMenuClick = (menu: any) => {
//     // If onClick prop is provided, use it
//     if (onClick) {
//       onClick(null, menu);
//       return;
//     }

//     setActiveMenu(menu.menuId);

//     if (menu.children && menu.children.length > 0) {
//       // This is a folder, toggle expand/collapse
//       toggleMenu(menu.menuId, menu.parentId);
//     } else {
//       // This is a file, navigate
//       if (!menu.permissions?.isView && menu.permissions?.isView !== undefined) {
//         toast.error(`You don't have permission to access ${menu.menuName}`);
//         return;
//       }

//       sessionStorage.setItem("menuId", menu.menuId.toString());
//       sessionStorage.setItem("menuName", menu.menuName);
//       sessionStorage.setItem("menuPermissions", JSON.stringify(menu.permissions || {}));

//       // Use path if available, otherwise construct from menuName
//       const path = menu.path || `/${menu.menuName?.replace(/\s+/g, "").toLowerCase()}`;
//       navigate(`${path}?appId=${menu.menuId}&Appname=${menu.menuName}.aspx`);
//     }
//   };

//   const toggleMenu = (menuId: number, parentId: number | null) => {
//     setOpenMenus((prev: Set<number>) => {
//       const newOpenMenus = new Set(prev);

//       if (newOpenMenus.has(menuId)) {
//         newOpenMenus.delete(menuId);
//       } else {
//         if (parentId === null) {
//           // If it's a root menu, close all other root menus
//           newOpenMenus.clear();
//         }
//         newOpenMenus.add(menuId);
//       }

//       return newOpenMenus;
//     });
//   };

//   // Improved renderMenu function
//   const renderMenu = (menus: any[], level = 0) => {
//     return menus.map((menu: any) => {
//       const hasChildren = menu.children && menu.children.length > 0;
//       const isOpen = openMenus.has(menu.menuId);

//       return (
//         <React.Fragment key={menu.menuId}>
//           <ListItem
//             disablePadding
//             sx={{
//               display: "block",
//               backgroundColor: activeMenu === menu.menuId ? "#dfe6f5" : "inherit",
//               "&:hover": { backgroundColor: "#f8f9fa" },
//               borderRadius: "6px",
//               transition: "background 0.2s ease-in-out",
//               marginBottom: "2px",
//             }}
//           >
//             <ListItemButton
//               sx={{
//                 minHeight: 48,
//                 justifyContent: open ? "initial" : "center",
//                 px: 2.5,
//                 pl: level * 2 + (open ? 2.5 : 1.5),
//               }}
//               onClick={() => handleMenuClick(menu)}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 0,
//                   mr: open ? 2 : "auto",
//                   justifyContent: "center",
//                   color: activeMenu === menu.menuId ? "#FF0000" : "#333",
//                 }}
//               >
//                 {hasChildren ? (
//                   isOpen ? (
//                     <FaRegFolderOpen style={{ color: "#42AEEE", fontSize: "18px" }} />
//                   ) : (
//                     <FolderIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//                   )
//                 ) : (
//                   <DescriptionIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//                 )}
//               </ListItemIcon>

//               <ListItemText
//                 primary={menu.menuName || ''}
//                 sx={{
//                   opacity: open ? 1 : 0,
//                   fontWeight: "bold",
//                   fontSize: "13px",
//                   color: activeMenu === menu.menuId ? "#0056b3" : "#333",
//                   "& .MuiListItemText-primary": {
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                   }
//                 }}
//               />

//               {hasChildren && open && (
//                 <Box sx={{ ml: 1 }}>
//                   {isOpen ? (
//                     <ExpandLessIcon fontSize="small" style={{ color: "#42AEEE" }} />
//                   ) : (
//                     <ExpandMoreIcon fontSize="small" style={{ color: "#42AEEE" }} />
//                   )}
//                 </Box>
//               )}
//             </ListItemButton>
//           </ListItem>

//           {/* Render children if menu is open */}
//           {hasChildren && isOpen && (
//             <Collapse in={isOpen} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 {renderMenu(menu.children, level + 1)}
//               </List>
//             </Collapse>
//           )}
//         </React.Fragment>
//       );
//     });
//   };

//   const handleClick = (event: any) => {
//     setAnchorEl(event.currentTarget);
//     setMenuOpen(true);
//     setHomeColor("inherit");
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setMenuOpen(false);
//   };

//   const routeChangeHome = () => {
//     navigate(`/home`);
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//     setOpenlogo(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//     setOpenlogo(false);
//   };

//   const handleLogout = () => {
//     dispatch(logoutAction());
//     sessionStorage.clear();
//     navigate("/");
//   };

//   const { i18n } = useTranslation();

//   const changeLanguage = (language: any) => {
//     i18n.changeLanguage(language);
//     localStorage.setItem("preferredLanguage", language);
//   };

//   var currentLanguage = localStorage.getItem("preferredLanguage");
//   var newLanguage = currentLanguage === "hi" ? "English" : "हिंदी";

//   const collapsehamndle = (index: any) => {
//     if (index == collapseIndex) {
//       setCollapseIndex(-1);
//     } else {
//       setCollapseIndex(index);
//     }
//   };

//   const getImageForFirstName = (userName: string) => {
//     const firstLetter = userName ? userName.charAt(0).toUpperCase() : "";
//     return `${firstLetter}`;
//   };

//   const getGenderText = (gendeR_ID: any) => {
//     switch (gendeR_ID) {
//       case 1:
//         return "Male";
//       case 2:
//         return "Female";
//       case 3:
//         return "Other";
//       default:
//         return "Unknown";
//     }
//   };

//   const handleMyProfileClick = () => {
//     setProfileDrawerOpen(!profileDrawerOpen);
//   };

//   const currentPathname = window.location.pathname;
//   const segments = currentPathname.split("/").filter(Boolean);

//   function handleClicked(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//     event.preventDefault();
//   }

//   const handleClickhome = () => {
//     navigate(`/home`);
//   };

//   const handleRightClick = (path: any) => (e: any) => {
//     e.preventDefault();
//     window.open(path, "_blank");
//   };

//   const [showThemeMenu, setShowThemeMenu] = React.useState(false);
//   const [selectedTheme, setSelectedTheme] = React.useState(() => {
//     const storedTheme = localStorage.getItem("theme");
//     return storedTheme ? storedTheme : themes[0]["name"];
//   });

//   React.useEffect(() => {
//     document.body.className = selectedTheme;
//     localStorage.setItem("theme", selectedTheme);
//   }, [selectedTheme]);

//   const handleThemeChange = (theme: any) => {
//     setSelectedTheme(theme);
//     setShowThemeMenu(false);
//   };

//   const handleCloseSelect = () => {
//     setShowThemeMenu(false);
//   };

//   const headerColor1 = `var(--header-background)`;
//   const drawerStyles = `var(--drawer-background)`;

//   // Debug log to see what items are being passed
//   console.log('Sidebar received items:', items);

//   // Don't render the sidebar if user is not authenticated
//   if (!isAuthenticated) {
//     return null;
//   }

//   return (
//     <Box sx={{ display: "flex" }}>
//       <AppBar position="fixed" open={open} style={{}}>
//         <Toolbar
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             background: `var(--header-background1)`,
//             color: `var(--header-color1)`,
//             borderBottom: "1px solid",
//             borderImage: "linear-gradient(to right,rgb(240, 123, 6), #FFFFFF,rgb(30, 239, 11)) 1",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-start",
//               alignItems: "center",
//             }}
//           >
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               onClick={handleDrawerOpen}
//               edge="start"
//               sx={{
//                 ...(open && { display: "none" }),
//               }}
//             >
//               <MenuIcon fontSize="large" />
//             </IconButton>

//             {!openlogo && <img src={logo} width={60} height={60} alt="Logo" />}
//           </div>

//           <div style={{ fontFamily: "Georgia, serif" }}>
//             <span style={{ fontSize: "3vw", color: "#FF671F" }}>V</span>
//             <span style={{ fontSize: "2.2vw" }}>ehicle </span>
//             <span style={{ fontSize: "3vw", color: "#D50E00" }}>T</span>
//             <span style={{ fontSize: "2.2vw" }}>racking </span>
//             <span style={{ fontSize: "3vw", color: "#FFE100" }}>S</span>
//             <span style={{ fontSize: "2.2vw" }}>ystem</span>
//           </div>

//           <IconButton
//             onClick={handleClick}
//             size="small"
//             sx={{ ml: 2 }}
//             aria-controls={open ? "account-menu" : undefined}
//             aria-haspopup="true"
//             aria-expanded={open ? "true" : undefined}
//           >
//             <Avatar sx={{ width: 40, height: 40 }}>
//               {menuData?.userName ? menuData.userName[0].toUpperCase() : 'U'}
//             </Avatar>
//           </IconButton>

//           <Menu
//             anchorEl={anchorEl}
//             id="account-menu"
//             open={menuOpen}
//             onClick={handleClose}
//             PaperProps={{
//               elevation: 0,
//               sx: {
//                 backgroundColor: `var(--menu-background)`,
//                 color: `var(--menu-color)`,
//                 overflow: "auto",
//                 filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//                 paddingRight: "10px",
//                 paddingLeft: "10px",
//                 mt: 1.5,
//                 "& .MuiAvatar-root": {
//                   width: 32,
//                   height: 32,
//                   ml: -0.5,
//                   mr: 1,
//                 },
//                 "&::before": {
//                   content: '""',
//                   display: "block",
//                   position: "absolute",
//                   top: 0,
//                   right: 14,
//                   width: 10,
//                   height: 10,
//                   bgcolor: "background.paper",
//                   transform: "translateY(-50%) rotate(45deg)",
//                   zIndex: 0,
//                 },
//               },
//             }}
//             transformOrigin={{ horizontal: "right", vertical: "top" }}
//             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//           >
//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={logged} width={40} height={40} alt="User" />
//               </ListItemIcon>
//               {menuData?.userName || "User"}
//             </MenuItem>

//             <MenuItem onClick={handleMyProfileClick}>
//               <ListItemIcon>
//                 <img src={id} width={30} height={30} alt="Profile" />
//               </ListItemIcon>
//               My Profile
//             </MenuItem>

//             <Divider />

//             <MenuItem
//               onClick={() => {
//                 localStorage.getItem("preferredLanguage") == "hi"
//                   ? changeLanguage("en")
//                   : changeLanguage("hi");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={trans} width={30} height={30} alt="Translate" />
//               </ListItemIcon>
//               Translate -- {newLanguage}
//             </MenuItem>

//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={settings} width={30} height={30} alt="Settings" />
//               </ListItemIcon>
//               Settings
//             </MenuItem>

//             <MenuItem onClick={() => setShowThemeMenu(!showThemeMenu)}>
//               <ListItemIcon>
//                 <img src={ThemeIcon} width={30} height={30} alt="Theme" />
//               </ListItemIcon>
//               Select Theme
//             </MenuItem>

//             <MenuItem
//               onClick={() => {
//                 let path = "/help/HelpDesk";
//                 window.open(path, "_blank");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={help} width={30} height={30} alt="Help Desk" />
//               </ListItemIcon>
//               Help Desk
//             </MenuItem>

//             <Divider />
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <img src={logout} width={30} height={30} alt="Logout" />
//               </ListItemIcon>
//               Logout
//             </MenuItem>
//           </Menu>
//         </Toolbar>

//         <Dialog open={showThemeMenu} onClose={handleCloseSelect}>
//           <DialogTitle>Select a Theme</DialogTitle>
//           <DialogContent>
//             <List>
//               {themes.map((theme) => (
//                 <ListItem
//                   button
//                   key={theme.name}
//                   onClick={() => handleThemeChange(theme.name)}
//                   selected={selectedTheme === theme.name}
//                 >
//                   {theme.icon}
//                   <span style={{ marginLeft: "10px" }}>{theme.name}</span>
//                 </ListItem>
//               ))}
//             </List>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseSelect}>Cancel</Button>
//           </DialogActions>
//         </Dialog>

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: headerColor1,
//             borderBottomRightRadius: "15px",
//             height: "30px", // Fixed height in pixels
//             padding: "0 15px",
//           }}
//         >
//           <div
//             role="presentation"
//             onClick={handleClicked}
//           >
//             <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff" }}>
//               <Typography
//                 sx={{
//                   display: "flex",
//                   color: "#fff",
//                   alignItems: "center",
//                 }}
//               >
//                 <Link
//                   underline="hover"
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                     cursor: "pointer",
//                   }}
//                   color="inherit"
//                   onClick={handleClickhome}
//                 >
//                   <HomeIcon sx={{ ml: 1, mr: 1 }} fontSize="inherit" />
//                   Home
//                 </Link>
//               </Typography>

//               {segments.slice(1).map((segment, index) => (
//                 <Typography
//                   key={index}
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                   }}
//                 >
//                   {index > 0 && " / "}
//                   {index === segments.length - 2 ? (
//                     <span>
//                       {segment}
//                     </span>
//                   ) : (
//                     <Link
//                       underline="hover"
//                       sx={{
//                         display: "flex",
//                         color: "#fff",
//                         alignItems: "center",
//                       }}
//                       color="inherit"
//                       href={`/${segments.slice(0, index + 1).join("/")}`}
//                     >
//                       {segment}
//                     </Link>
//                   )}
//                 </Typography>
//               ))}
//             </Breadcrumbs>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               gap: 15,
//               paddingRight: "15px",
//             }}
//           >
//             <p style={{ fontSize: "1.2vw", color: greeting.color }}>
//               {greeting.icon} {greeting.text}
//             </p>
//             <p> Time : {date.toLocaleTimeString()}</p>
//             <p> Date : {formattedDate}</p>
//           </div>
//         </div>
//       </AppBar>

//       <Drawer
//         variant="permanent"
//         open={open}
//         PaperProps={{
//           sx: {
//             backgroundColor: drawerStyles,
//             color: `var(--drawer-color)`,
//             overflowX: 'hidden',
//           },
//         }}
//       >
//         <DrawerHeader>
//           <>
//             <Stack sx={{ width: "100%", height: "14vh" }} direction="row" justifyContent="center">
//               {openlogo ? (
//                 <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
//                   <img src={loged} width={100} height={100} alt="Logo" />
//                 </div>
//               ) : (
//                 <div style={{ padding: 0 }}></div>
//               )}
//             </Stack>

//             <IconButton onClick={handleDrawerClose}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//             <br />
//             <br />
//           </>
//         </DrawerHeader>

//         <br />
//         <br />
//         <Divider />
//         {openlogo && (
//           <Paper
//             component="form"
//             sx={{
//               m: "5px 5px",
//               p: "0px 2px",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <Autocomplete
//               freeSolo
//               fullWidth
//               size="small"
//               options={items.reduce((acc: any, item: any) => {
//                 if (item.children) {
//                   acc.push(...item.children.map((subItem: any) => subItem.menuName));
//                 }
//                 return acc;
//               }, [])}
//               onChange={handleAutocompleteChange}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   placeholder="Search Menu"
//                   variant="outlined"
//                   InputProps={{
//                     ...params.InputProps,
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={handleSearchInputChange}
//                 />
//               )}
//             />
//           </Paper>
//         )}
//         <Divider />

//         <List sx={{ overflowY: 'auto', overflowX: 'hidden', height: 'calc(100vh - 250px)' }}>
//           {/* Home List */}
//           <ListItem disablePadding>
//             <ListItemButton
//               sx={{
//                 minHeight: 48,
//                 justifyContent: open ? "initial" : "center",
//                 px: 2.5,
//               }}
//               onClick={() => {
//                 routeChangeHome();
//                 resetHomeColor();
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 0,
//                   mr: open ? 2 : "auto",
//                   justifyContent: "center",
//                   color: homeColor,
//                 }}
//               >
//                 <HomeIcon />
//               </ListItemIcon>
//               <ListItemText primary="Home" sx={{ opacity: open ? 1 : 0 }} />
//             </ListItemButton>
//           </ListItem>

//           <Divider />

//           {/* Dynamic Items List */}
//           {items && items.length > 0 ? (
//             renderMenu((filteredItems.length > 0) ? filteredItems : items)
//           ) : (
//             <Typography sx={{ p: 2, textAlign: 'center', color: 'gray' }}>
//               No menus available
//             </Typography>
//           )}
//         </List>
//       </Drawer>

//       <Modal open={isModalOpen} onClose={handleCloseModal}>
//         <Box sx={style}>
//           <Typography fontWeight={500} fontSize={20} noWrap align="center">
//             Node Permission
//           </Typography>
//           <div>
//             <Grid xs={12} item>
//               <Box>
//                 <div style={{ height: "400px", overflow: "auto" }}>
//                   <SimpleTreeView expandedItems={expandedItems}>
//                     {Array.isArray(treedata)
//                       ? treedata.map((node: any) => renderTree(node))
//                       : null}
//                   </SimpleTreeView>
//                 </div>
//               </Box>
//             </Grid>
//             <Grid xs={3} item alignItems="center" justifyContent="center">
//               <Button
//                 type="submit"
//                 fullWidth
//                 style={{
//                   backgroundColor: "#059669",
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 onClick={handleSave}
//               >
//                 {t("text.save")}
//               </Button>
//             </Grid>
//           </div>
//         </Box>
//       </Modal>

//       <SwipeableDrawer
//         anchor="left"
//         open={profileDrawerOpen}
//         onClose={() => {
//           setProfileDrawerOpen(false);
//         }}
//         onOpen={() => { }}
//         style={{
//           zIndex: 1300,
//         }}
//       >
//         <Box sx={{ width: drawerWidth }} role="presentation">
//           <IconButton
//             edge="end"
//             onClick={() => setProfileDrawerOpen(false)}
//             aria-label="close"
//             sx={{ color: "white", position: "absolute", right: 15, top: 2 }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <p
//             style={{
//               paddingTop: "5vh",
//               paddingBottom: "5vh",
//               textAlign: "center",
//               backgroundImage:
//                 "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//               color: "whitesmoke",
//               borderBottomLeftRadius: "10px",
//               borderBottomRightRadius: "10px",
//               fontSize: "20px",
//             }}
//           >
//             User Details
//           </p>

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginTop: "10px",
//               marginBottom: "10px",
//             }}
//           >
//             <div
//               style={{
//                 textAlign: "center",
//                 borderRadius: "50%",
//                 height: "90px",
//                 width: "90px",
//                 borderColor:
//                   "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//                 backgroundColor: "red",
//                 padding: "13px",
//                 paddingTop: "30px",
//                 paddingLeft: "13px",
//                 color: "whitesmoke",
//                 fontSize: "20px",
//               }}
//             >
//               {getImageForFirstName(menuData?.userName || '')}
//             </div>
//           </div>

//           <div style={{ marginLeft: "15px" }}>
//             {menuData?.userName && menuData.userName.trim() !== "" && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={log} width={25} alt="Username" />
//                 {menuData.userName}
//               </div>
//             )}
//             <br />

//             {menuData?.email && menuData.email.trim() !== "" && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={emails} width={25} alt="Email" />
//                 {menuData.email}
//               </div>
//             )}
//             <br />

//             {menuData?.phoneNumber && (
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 20,
//                 }}
//               >
//                 <img src={call} width={25} alt="Phone" />
//                 {menuData.phoneNumber}
//               </div>
//             )}
//             <br />

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//               }}
//             >
//               Account Status :
//               {menuData?.emailConfirmed ? (
//                 <img src={tick} width={25} alt="Active" />
//               ) : (
//                 <img src={crs} width={25} alt="Inactive" />
//               )}
//             </div>
//           </div>
//         </Box>
//       </SwipeableDrawer>
//     </Box>
//   );
// }






























// import * as React from "react";
// import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import CssBaseline from "@mui/material/CssBaseline";
// import Typography from "@mui/material/Typography";
// import Divider from "@mui/material/Divider";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import { useNavigate, Navigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import {
//   Avatar,
//   Checkbox,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Modal,
//   Stack,
// } from "@mui/material";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import call from "../../assets/images/phone-call.png";
// import roles from "../../assets/images/role-model.png";
// import tick from "../../assets/images/check-mark.png";
// import crs from "../../assets/images/cross.png";
// import log from "../../assets/images/profile.png";
// import emails from "../../assets/images/gmail.png";
// import genders from "../../assets/images/symbol.png";
// import dobs from "../../assets/images/timetable.png";
// import id from "../../assets/images/profile1.png";
// import settings from "../../assets/images/settings.png";
// import trans from "../../assets/images/translation.png";
// import logout from "../../assets/images/logout.png";
// import logged from "../../assets/images/permission.png";
// import logo from "../../assets/images/recyclebinLogo.png";
// import help from "../../assets/images/help.png";
// import loged from "../../assets/images/DrawerLogo.png";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";
// import { Home } from "@mui/icons-material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import Collapse from "@mui/material/Collapse";
// import Typewriter from "./TypeWriter";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import FolderIcon from "@mui/icons-material/Folder";
// import TouchAppIcon from "@mui/icons-material/TouchApp";
// import "./Shine.css";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "@mui/material/Link";
// import HomeIcon from "@mui/icons-material/Home";
// import WhatshotIcon from "@mui/icons-material/Whatshot";
// import GrainIcon from "@mui/icons-material/Grain";
// import names from "../../assets/images/id-card (2).png";
// import backgrd from "../../assets/images/backgroundimage.jpg";
// import SearchIcon from "@mui/icons-material/Search";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import Autocomplete from "@mui/material/Autocomplete";
// import InputAdornment from "@mui/material/InputAdornment";
// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   // Typography,
// } from "@mui/material";
// import "./ThemeStyle.css";
// import ThemeIcon from "../../assets/images/themes.png";
// import {
//   Brightness5,
//   Brightness4,
//   Waves,
//   WbSunny,
//   Forest,
//   Flag,
// } from "@mui/icons-material";
// import api from "../../utils/Url";
// import { toast } from "react-toastify";
// import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
// import TreeView from "@mui/x-tree-view/TreeView";
// import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";

// import { FaRegFolderOpen } from "react-icons/fa6";
// import DescriptionIcon from '@mui/icons-material/Description';

// import { FaFileLines } from "react-icons/fa6";
// import { Tooltip } from '@mui/material';

// import { useDispatch } from 'react-redux';
// // import { clearUserDetails } from '../../redux/userSlice';



// const drawerWidth = 225;


// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// const openedMixin = (theme: Theme): CSSObject => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme: Theme): CSSObject => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(12)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// interface AppBarProps extends MuiAppBarProps {
//   open?: boolean;
// }

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })<AppBarProps>(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// function getGreeting() {
//   const hour = new Date().getHours();

//   let greeting;
//   if (hour < 12) {
//     greeting = {
//       text: "Good Morning",
//       color: "#FFFFE0",
//       icon: "🌅", // Sunrise emoji
//     };
//   } else if (hour < 17) {
//     greeting = {
//       text: "Good Afternoon",
//       color: "#FFE4B5",
//       icon: "🌞", // Sun emoji
//     };
//   } else {
//     greeting = {
//       text: "Good Evening",
//       color: "#FFDAB9",
//       icon: "🌜", // Crescent moon emoji
//     };
//   }

//   return greeting;
// }

// export default function MiniDrawer({ items }: any) {


//   const dispatch = useDispatch();

//   // console.log('items',items);
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);
//   const [menuOpen, setMenuOpen] = React.useState(false);
//   const [profileDrawerOpen, setProfileDrawerOpen] = React.useState(false);
//   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
//   const [collapseIndex, setCollapseIndex] = React.useState<any>(-1);
//   const [openlogo, setOpenlogo] = React.useState(true);
//   const [homeColor, setHomeColor] = React.useState("inherit");
//   const { t } = useTranslation();

//   const [selectedSubMenu, setSelectedSubMenu] = React.useState(null);

//   const [expandedItems, setExpandedItems] = React.useState<any[]>([]);
//   const [isModalOpen, setIsModalOpen] = React.useState(false);

//   const [treedata, setTreedata] = React.useState<any>([]);
//   // console.log("data", treedata)
//   const [check, setCheck] = React.useState<any>([]);

//   const [searchValue, setSearchValue] = React.useState("");
//   // const [filteredItems, setFilteredItems] = React.useState([]);
//   const [filteredItems, setFilteredItems] = React.useState<MenuItem[]>([]);
//   const [activeMenu, setActiveMenu] = React.useState<number | null>(null)
//   const [openMenus, setOpenMenus] = React.useState<Set<number>>(new Set());



//   const themes = [
//     { name: "light-theme", icon: <Brightness5 /> },
//     { name: "dark-theme", icon: <Brightness4 /> },
//     { name: "ocean-theme", icon: <Waves /> },
//     { name: "sunset-theme", icon: <WbSunny /> },
//     { name: "forest-theme", icon: <Forest /> },
//     { name: "bhagwa-theme", icon: <Flag /> },
//   ];



//   const menuData = JSON.parse(localStorage.getItem("userDetail")!);

//   const greeting = getGreeting();

//   let navigate = useNavigate();

//   function searchMenuItems(items: any, query: string) {
//     const results = [];

//     for (const menuItem of items) {
//       if (menuItem.name.toLowerCase().includes(query.toLowerCase())) {
//         results.push(menuItem);
//       } else if (menuItem.items && menuItem.items.length > 0) {
//         const matchingSubItems = menuItem.items.filter(
//           (subItem: { name: string }) =>
//             subItem.name.toLowerCase().includes(query.toLowerCase())
//         );
//         if (matchingSubItems.length > 0) {
//           results.push({ ...menuItem, items: matchingSubItems });
//         }
//       }
//     }
//     return results;
//   }

//   interface MenuItem {
//     Icon: any;
//     displayNo: number;
//     id: number;
//     items: MenuItem[];
//     label: string;
//     name: string;
//     path: string;
//   }

//   const handleSearchIconClick = () => {
//     console.log("value", searchValue);
//     const filtered = searchMenuItems(items, searchValue);
//     setFilteredItems(filtered);
//     console.log("filtered", filtered);
//   };

//   const handleNavigation = (path: any) => {
//     console.log("Navigating to:", path);
//     navigate(path);
//   };

//   const handleAutocompleteChange = (event: any, value: any) => {
//     const selectedItem = items.find((item: any) =>
//       item.items.some((subItem: any) => subItem.name === value)
//     );
//     if (selectedItem) {
//       const selectedSubItem = selectedItem.items.find(
//         (subItem: any) => subItem.name === value
//       );
//       if (selectedSubItem) {
//         handleNavigation(selectedSubItem.path);
//       }
//     }
//   };

//   const allMenuNames = items.reduce((acc: any, item: { items: any[] }) => {
//     if (item.items) {
//       return [
//         ...acc,
//         ...item.items.map((subItem: { name: any }) => subItem.name),
//       ];
//     }
//     return acc;
//   }, []);

//   const filteredItemed = allMenuNames.filter((item: string) =>
//     item.toLowerCase().includes(searchValue.toLowerCase())
//   );




//   const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value.toLowerCase();
//     setSearchValue(value);

//     const expandedMenuIds: any = new Set();

//     if (value === "") {
//       // If search is cleared, collapse all menus
//       setFilteredItems(items);
//       setOpenMenus(new Set());
//       return;
//     }

//     const filtered = items.reduce((acc: any, menu: any) => {

//       if (menu.menuName.toLowerCase().includes(value)) {
//         acc.push(menu);
//         expandedMenuIds.add(menu.menuId);
//       } else if (menu.children) {

//         const filteredChildren = menu.children.filter((child: any) =>
//           child.menuName.toLowerCase().includes(value)
//         );


//         //console.log(filteredChildren)

//         if (filteredChildren.length > 0) {
//           acc.push({ ...menu, children: filteredChildren });
//           expandedMenuIds.add(menu.menuId);
//         }
//       }
//       return acc;
//     }, []);

//     setFilteredItems(filtered);
//     setOpenMenus(expandedMenuIds);
//   };


//   var [date, setDate] = React.useState(new Date());

//   const options: Intl.DateTimeFormatOptions = {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   };

//   const formattedDate = date
//     .toLocaleDateString("en-US", options)
//     .split(" ")
//     .map((part, index) =>
//       index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
//     )
//     .join(" ");

//   React.useEffect(() => {
//     var timer = setInterval(() => setDate(new Date()), 1000);
//     return function cleanup() {
//       clearInterval(timer);
//     };
//   });

//   const handleSubMenuClick = (index: any) => {
//     console.log(index);
//     setSelectedSubMenu(index);
//   };
//   const resetHomeColor = () => {
//     // setHomeColor("inherit");
//     setHomeColor("#FF0000");
//     // setHomeColor("");
//   };



//   const handleMenuClick = (menu: any) => {
//     setActiveMenu(menu.menuId); // Highlight active menu

//     if (menu.children && menu.children.length > 0) {
//       toggleMenu(menu.menuId, menu.parentId); // Toggle submenu
//     } else if (menu.path) {
//       navigate(menu.path); // Navigate only if no children exist
//     }
//   };

//   const toggleMenu = (menuId: number, parentId: number | null) => {
//     setOpenMenus((prev: Set<number>) => {
//       const newOpenMenus = new Set(prev);

//       if (newOpenMenus.has(menuId)) {
//         // If the clicked menu is already open, close it
//         newOpenMenus.delete(menuId);
//       } else {
//         // Close other parent menus if this is a top-level menu (parentId === null)
//         if (parentId === null) {
//           newOpenMenus.clear(); // Collapse all parent menus
//         }

//         newOpenMenus.add(menuId); // Open the clicked menu
//       }

//       return newOpenMenus;
//     });
//   };

//   //  React.useEffect(() => {
//   //   {renderMenu((filteredItems.length > 0) ? filteredItems : items)}

//   //  },[filteredItems])






//   const renderMenu = (menus: any[], level = 0) => {

//     // console.log('checkRenderMenu',menus,level)



//     return menus.map((menu: any) => (
//       <List key={menu.menuId} sx={{ paddingY: 0.5, paddingX: 0 }}>
//         <Divider />

//         {/* Menu Item */}
//         <ListItem
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: activeMenu === menu.menuId ? "#dfe6f5" : "inherit",
//             paddingLeft: `${level * 14}px`,
//             paddingY: 0.3, // Reduced vertical padding
//             cursor: "pointer",
//             "&:hover": { backgroundColor: "#f8f9fa" },
//             borderRadius: "6px",
//             transition: "background 0.2s ease-in-out",
//           }}
//           onClick={() => handleMenuClick(menu)}
//         >
//           {/* Left Section: Icon + Menu Name */}
//           <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
//             <ListItemIcon
//               sx={{
//                 minWidth: "32px",
//                 justifyContent: "center",
//                 color: activeMenu === menu.menuId ? "#FF0000" : "#333",
//                 fontWeight: 600,
//               }}
//               onClick={(e: any) => {
//                 e.stopPropagation(); // Prevents ListItem click event
//                 toggleMenu(menu.menuId, menu.parentId);
//               }}
//             >
//               {menu.children && menu.children.length > 0 ? (
//                 openMenus.has(menu.menuId) ? (
//                   <FaRegFolderOpen style={{ color: "#42AEEE", fontSize: "18px" }} />
//                 ) : (
//                   <FolderIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//                 )
//               ) : (
//                 <DescriptionIcon style={{ color: "#42AEEE", fontSize: "18px" }} />
//               )}
//             </ListItemIcon>

//             {/* Tooltip added here for full menu name */}
//             <Tooltip title={menu.menuName} arrow>
//               <ListItemText
//                 primary={open ? menu.menuName : menu.menuName.charAt(0).toUpperCase()} // Show first letter if closed
//                 sx={{
//                   fontWeight: "bold",
//                   fontSize: "13px",
//                   color: activeMenu === menu.menuId ? "#0056b3" : "#333",
//                   transition: "color 0.2s ease-in-out",
//                   // Styling for truncation when menu name is long
//                   overflow: "hidden",
//                   whiteSpace: "nowrap",
//                   textOverflow: "ellipsis",
//                 }}
//               />
//             </Tooltip>
//           </Box>

//           {/* ✅ Right Section: Caret for Expand/Collapse */}
//           {menu.children && menu.children.length > 0 && (
//             <ListItemIcon
//               sx={{
//                 paddingRight: "16px",
//                 minWidth: "32px",
//                 justifyContent: "flex-end",
//                 cursor: "pointer",
//                 color: "#42AEEE",
//               }}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 toggleMenu(menu.menuId, menu.parentId);
//               }}
//             >
//               {openMenus.has(menu.menuId) ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
//             </ListItemIcon>
//           )}
//         </ListItem>

//         {/* Recursive Rendering for Submenus */}
//         {openMenus.has(menu.menuId) && menu.children && menu.children.length > 0 && (
//           <List sx={{ paddingLeft: 2, backgroundColor: "inherit" }}>
//             {renderMenu(menu.children, level + 1)}
//           </List>
//         )}
//       </List>
//     ));
//   };



//   const backgroundStyle = {
//     background: "linear-gradient(45deg, #fff, #f0f)",
//     backgroundSize: "400% 400%",
//   };

//   const handleClick = (event: any) => {
//     setAnchorEl(event.currentTarget);
//     setMenuOpen(true);
//     setHomeColor("inherit");
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setMenuOpen(false);
//   };

//   const routeChangeHome = () => {
//     let path = `/home`;
//     navigate(path);
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//     setOpenlogo(true);
//   };

//   const handleDrawerClose = () => {
//     setOpen(false);
//     setOpenlogo(false);
//   };

//   const Logout = () => {
//     localStorage.removeItem("userdata");


//     // dispatch(clearUserDetails());


//     navigate("/");
//   };

//   function onClick(e: any, item: any) {
//     // console.log("Main " + item);

//     let path = item.path;
//     if (path == "" || path == null || path == "undefind") {
//       window.alert("Path Not Found ????");
//     } else {
//       navigate(path);
//     }
//   }

//   // var data = JSON.parse(localStorage.getItem("userdata")!);
//   // var menudata = data[0]["userdetail"];
//   // var username =
//   //   menudata[0]["firsT_NAME"] +
//   //   " " +
//   //   menudata[0]["middlE_NAME"] +
//   //   " " +
//   //   menudata[0]["suR_NAME"];
//   const { i18n } = useTranslation();

//   const changeLanguage = (language: any) => {
//     // console.log("check", language);

//     i18n.changeLanguage(language);
//     localStorage.setItem("preferredLanguage", language);
//   };
//   var currentLanguage = localStorage.getItem("preferredLanguage");
//   var newLanguage = currentLanguage === "hi" ? "English" : "हिंदी";

//   const userData = JSON.parse(localStorage.getItem("userdata")!) || {};
//   const userDetail = userData[0]?.userdetail || [];
//   // console.log(userDetail);

//   const collapsehamndle = (index: any) => {
//     // console.log(index);
//     if (index == collapseIndex) {
//       setCollapseIndex(-1);
//     } else {
//       setCollapseIndex(index);
//     }
//   };
//   // console.log("items", items);

//   const getImageForFirstName = (
//     firsT_NAME: any,

//   ) => {
//     const firstLetter = firsT_NAME ? firsT_NAME.charAt(0).toUpperCase() : "";

//     return `${firstLetter}`;
//   };

//   const getGenderText = (gendeR_ID: any) => {
//     switch (gendeR_ID) {
//       case 1:
//         return "Male";
//       case 2:
//         return "Female";
//       case 3:
//         return "Other";
//       default:
//         return "Unknown";
//     }
//   };

//   const handleMyProfileClick = () => {
//     // console.log("My Profile clicked" + profileDrawerOpen);
//     setProfileDrawerOpen(!profileDrawerOpen);
//   };

//   const currentPathname = window.location.pathname;
//   const segments = currentPathname.split("/").filter(Boolean);
//   const isHomePage = segments.length === 0;

//   function handleClicked(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//     event.preventDefault();
//     // console.info("You clicked a breadcrumb.");
//   }

//   const handleClickhome = () => {
//     let path = `/home`;
//     navigate(path);
//   };

//   function FirstLetters(props: any) {
//     const { text } = props;

//     const words = text.split(" ");

//     // Extract the first letter from each word
//     const firstLetters = words.map((word: any) => word.charAt(0));

//     // Join the first letters back into a string
//     const result = firstLetters.join("");

//     return <div>{result}</div>;
//   }

//   const handleRightClick = (path: any) => (e: any) => {
//     e.preventDefault();
//     window.open(path, "_blank");
//   };

//   const [showThemeMenu, setShowThemeMenu] = React.useState(false);

//   const [selectedTheme, setSelectedTheme] = React.useState(() => {
//     const storedTheme = localStorage.getItem("theme");

//     return storedTheme ? storedTheme : themes[0]["name"];
//   });

//   React.useEffect(() => {
//     console.log(selectedTheme);
//     document.body.className = selectedTheme;

//     localStorage.setItem("theme", selectedTheme);
//   }, [selectedTheme]);

//   const handleThemeChange = (theme: any) => {
//     setSelectedTheme(theme);
//     setShowThemeMenu(false);
//   };

//   const handleCloseSelect = () => {
//     setShowThemeMenu(false);
//   };

//   const headerColor1 = `var(--header-background)`;
//   const drawerStyles = `var(--drawer-background)`;

//   // let ID: any = localStorage.getItem("useR_ID");
//   // ID = ID.replace(/^"(.*)"$/, "$1");
//   // const handlePermissionClick = () => {
//   //   if (ID) {
//   //     console.log("id check 175", ID);
//   //     getNode(ID);
//   //   } else {
//   //     toast.error("ID not found");
//   //   }
//   //   setIsModalOpen(true);
//   //   console.log("first");
//   // };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const getNode = (id: any) => {
//     const collectData = {
//       id: -1,
//       nodeID: -1,
//       titleID: -1,
//       user_Id: id,
//     };
//     api
//       .post(`NewNodeMaster/GetNewNodeMasterHeirarical`, collectData)
//       .then((res: any) => {
//         if (res.data && res.data.data && res.data.data.length > 0) {
//           setTreedata(res.data.data);
//           const allNodeIds = getAllNodeIds(res.data.data);
//           setExpandedItems(allNodeIds);
//         } else {
//           toast.error("Data is null or empty");
//         }
//       });
//   };

//   const getAllNodeIds = (nodes: any[]): string[] => {
//     let ids: string[] = [];

//     const collectIds = (nodes: any[]) => {
//       nodes.forEach((node) => {
//         ids.push(node.id.toString());
//         if (node.childnode) {
//           collectIds(node.childnode);
//         }
//       });
//     };

//     collectIds(nodes);

//     return ids;
//   };

//   const defaultSelectedNodeId = parseInt(localStorage.getItem("id") + "");

//   React.useEffect(() => {
//     // Set default selected node here
//     if (defaultSelectedNodeId) {
//       setCheck([defaultSelectedNodeId]);
//     }

//     const initialExpanded = getAllNodeIds(treedata);
//     setExpandedItems(initialExpanded);
//   }, [defaultSelectedNodeId, treedata]);

//   const [nodeId, setnodeId] = React.useState<any>(0);
//   const [nodeNames, setNodeNames] = React.useState<string>("");

//   // Effect to apply the theme from local storage

//   const handleToggle = (id: number, name: string) => () => {
//     const currentIndex = check.indexOf(id);
//     //const newChecked = [...check];
//     const newChecked = currentIndex === -1 ? [id] : [];
//     //const updatedChecked = currentIndex === -1 ? [id] : [];

//     if (currentIndex === -1) {
//       newChecked.push(id);
//     } else {
//       newChecked.splice(currentIndex, 1);
//     }

//     setCheck(newChecked);

//     // setExpandedItems((prevExpanded) =>
//     //   prevExpanded.includes(id.toString())
//     //     ? prevExpanded.filter((item) => item !== id.toString())
//     //     : [...prevExpanded, id.toString()]
//     // );

//     console.log("Checked data:", name);
//     console.log("Checked data:", id);

//     setNodeNames(name);
//     setnodeId(id);
//     // handleSave(id, name);
//   };

//   const handleSave = () => {
//     console.log("handleSave function called");

//     if (nodeId != 0 || nodeNames != "") {
//       localStorage.setItem("id", nodeId);
//       localStorage.setItem("nodeName", nodeNames);
//       console.log("Checked Save:", { nodeId, nodeNames });

//       handleCloseModal();
//     } else {
//       toast.error("Please Retry... Network Issues");
//     }
//   };

//   const renderTree = (nodes: any) => (
//     <TreeItem
//       key={nodes.id}
//       itemId={String(nodes.id)}
//       label={
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <Checkbox
//             checked={check.indexOf(nodes.id) !== -1}
//             // onChange={handleToggle(nodes.id)}

//             onChange={handleToggle(nodes.id, nodes.name)}
//             onClick={(event: any) => event.stopPropagation()}
//           />

//           <div style={{ marginLeft: 8 }}>{nodes.name}</div>
//         </div>
//       }
//       onClick={() => toggleExpansion(nodes.id.toString())}
//     >
//       {Array.isArray(nodes.childnode)
//         ? nodes.childnode.map((node: any) => renderTree(node))
//         : null}
//     </TreeItem>
//   );

//   const toggleExpansion = (nodeId: string) => {
//     if (expandedItems.includes(nodeId)) {
//       setExpandedItems(expandedItems.filter((item) => item !== nodeId));
//     } else {
//       setExpandedItems([...expandedItems, nodeId]);
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       {/* <CssBaseline /> */}
//       <AppBar position="fixed" open={open} style={{}}>
//         <Toolbar
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             background: `var(--header-background1)`,
//             color: `var(--header-color1)`,
//             borderBottom: "1px solid",
//             borderImage: "linear-gradient(to right,rgb(240, 123, 6), #FFFFFF,rgb(30, 239, 11)) 1",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-start",
//               alignItems: "center",
//               // paddingTop: "10px",
//               // paddingBottom: "10px",
//             }}
//           >
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               onClick={handleDrawerOpen}
//               edge="start"
//               sx={{
//                 // marginRight: 5,
//                 ...(open && { display: "none" }),
//               }}
//             >
//               <MenuIcon fontSize="large" />
//             </IconButton>

//             {!openlogo && <img src={logo} width={60} height={60} />}
//           </div>

//           {/* <div style={{ fontSize: "3vw" }}>Vehicle Tracking System</div> */}


//           <div style={{ fontFamily: "Georgia, serif" }}>
//             <span style={{ fontSize: "3vw", color: "#FF671F" }}>V</span>
//             <span style={{ fontSize: "2.2vw" }}>ehicle </span>
//             <span style={{ fontSize: "3vw", color: "#D50E00" }}>T</span>
//             <span style={{ fontSize: "2.2vw" }}>racking </span>
//             <span style={{ fontSize: "3vw", color: "#FFE100" }}>S</span>
//             <span style={{ fontSize: "2.2vw" }}>ystem</span>
//           </div>

//           <IconButton
//             onClick={handleClick}
//             size="small"
//             sx={{ ml: 2 }}
//             aria-controls={open ? "account-menu" : undefined}
//             aria-haspopup="true"
//             aria-expanded={open ? "true" : undefined}
//           >
//             <Avatar sx={{ width: 40, height: 40 }}>
//               {/* {username[0].toUpperCase()} */}
//             </Avatar>
//           </IconButton>

//           <Menu
//             anchorEl={anchorEl}
//             id="account-menu"
//             open={menuOpen}
//             // onClose={handleClose}
//             onClick={handleClose}
//             PaperProps={{
//               elevation: 0,
//               sx: {
//                 backgroundColor: `var(--menu-background)`,
//                 color: `var(--menu-color)`,
//                 overflow: "auto",
//                 filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//                 paddingRight: "10px",
//                 paddingLeft: "10px",
//                 mt: 1.5,
//                 "& .MuiAvatar-root": {
//                   width: 32,
//                   height: 32,
//                   ml: -0.5,
//                   mr: 1,
//                 },
//                 "&::before": {
//                   content: '""',
//                   display: "block",
//                   position: "absolute",
//                   top: 0,
//                   right: 14,
//                   width: 10,
//                   height: 10,
//                   bgcolor: "background.paper",
//                   transform: "translateY(-50%) rotate(45deg)",
//                   zIndex: 0,
//                 },
//               },
//             }}
//             transformOrigin={{ horizontal: "right", vertical: "top" }}
//             anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//           >
//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={logged} width={40} height={40} />
//               </ListItemIcon>
//               {" "}{menuData?.userName}
//             </MenuItem>
//             {/* <MenuItem > */}
//             <MenuItem onClick={handleMyProfileClick}>
//               <ListItemIcon>
//                 <img src={id} width={30} height={30} />
//               </ListItemIcon>
//               My Profile
//             </MenuItem>

//             <Divider />

//             <MenuItem
//               onClick={() => {
//                 localStorage.getItem("preferredLanguage") == "hi"
//                   ? changeLanguage("en")
//                   : changeLanguage("hi");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={trans} width={30} height={30} />
//               </ListItemIcon>
//               Translate -- {newLanguage}
//             </MenuItem>
//             <MenuItem onClick={handleClose}>
//               <ListItemIcon>
//                 <img src={settings} width={30} height={30} />
//               </ListItemIcon>
//               Settings
//             </MenuItem>

//             {/* <MenuItem onClick={handlePermissionClick}>
//               <ListItemIcon>
//                 <img src={logged} width={40} height={40} alt="Permission" />
//               </ListItemIcon>
//               Permission
//             </MenuItem> */}

//             <MenuItem onClick={() => setShowThemeMenu(!showThemeMenu)}>
//               <ListItemIcon>
//                 <img src={ThemeIcon} width={30} height={30} />
//               </ListItemIcon>
//               Select Theme
//             </MenuItem>


//             <MenuItem
//               onClick={() => {
//                 let path = "/help/HelpDesk";
//                 // localStorage.setItem("menuData", menuData.toString());
//                 window.open(path, "_blank");
//               }}
//             >
//               <ListItemIcon>
//                 <img src={help} width={30} height={30} alt="Help Desk" />
//               </ListItemIcon>
//               Help Desk
//             </MenuItem>

//             <Divider />
//             <MenuItem onClick={Logout}>
//               <ListItemIcon>
//                 <img src={logout} width={30} height={30} />
//               </ListItemIcon>
//               Logout
//             </MenuItem>
//           </Menu>
//         </Toolbar>

//         <Dialog open={showThemeMenu} onClose={handleCloseSelect}>
//           <DialogTitle>Select a Theme</DialogTitle>
//           <DialogContent>
//             <List>
//               {themes.map((theme) => (
//                 <ListItem
//                   button
//                   key={theme.name}
//                   onClick={() => handleThemeChange(theme.name)}
//                   selected={selectedTheme === theme.name}
//                 >
//                   {theme.icon}
//                   <span style={{ marginLeft: "10px" }}>{theme.name}</span>
//                 </ListItem>
//               ))}
//             </List>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseSelect}>Cancel</Button>
//           </DialogActions>
//         </Dialog>

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: headerColor1,
//             borderBottomRightRadius: "15px",
//           }}
//         >
//           <div
//             role="presentation"
//             onClick={handleClicked}
//           // style={{  borderBottomRightRadius: "15px" }}
//           >
//             <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff" }}>
//               {/* <Link
//                 underline="hover"
//                 sx={{ display: "flex", alignItems: "center" }}
//                 color="inherit"
//                 href="/"
//               >
//                 <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
//                 Home
//               </Link> */}
//               <Typography
//                 sx={{
//                   display: "flex",
//                   color: "#fff",
//                   alignItems: "center",
//                 }}
//               >
//                 <Link
//                   underline="hover"
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                     cursor: "pointer",
//                   }}
//                   color="inherit"
//                   onClick={handleClickhome}
//                 >
//                   <HomeIcon sx={{ ml: 1, mr: 1 }} fontSize="inherit" />
//                   Home
//                 </Link>
//               </Typography>

//               {/* Render the rest of the breadcrumb path */}
//               {segments.slice(1).map((segment, index) => (
//                 <Typography
//                   key={index}
//                   sx={{
//                     display: "flex",
//                     color: "#fff",
//                     alignItems: "center",
//                   }}
//                 >
//                   {/* {" / "} */}
//                   {index > 0 && " / "}
//                   {index === segments.length - 2 ? (
//                     <span>
//                       {" "}
//                       {/* <GrainIcon sx={{ mr: 0.5 }} fontSize="inherit" /> */}
//                       {segment}
//                     </span>
//                   ) : (
//                     <Link
//                       underline="hover"
//                       sx={{
//                         display: "flex",
//                         color: "#fff",
//                         alignItems: "center",
//                       }}
//                       color="inherit"
//                       href={`/${segments.slice(0, index + 1).join("/")}`}
//                     >
//                       {/* <WhatshotIcon sx={{ mr: 0.5 }} fontSize="inherit" /> */}
//                       {segment}
//                     </Link>
//                   )}
//                 </Typography>
//               ))}
//             </Breadcrumbs>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               gap: 15,
//               paddingRight: "15px",
//             }}
//           >
//             <p style={{ fontSize: "1.2vw", color: greeting.color }}>
//               {greeting.icon} {greeting.text}
//             </p>
//             <p> Time : {date.toLocaleTimeString()}</p>
//             <p> Date : {formattedDate}</p>
//           </div>
//         </div>
//       </AppBar>

//       <Drawer
//         variant="permanent"
//         open={open}
//         PaperProps={{
//           sx: {
//             backgroundColor: drawerStyles,
//             color: `var(--drawer-color)`,
//           },
//         }}
//       >
//         <DrawerHeader>
//           <>
//             <Stack sx={{ width: "100%", height: "14vh" }} direction="row" justifyContent="center">
//               {openlogo ? (
//                 <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
//                   <img src={loged} width={100} height={100} />
//                 </div>
//               ) : (
//                 <div style={{ padding: 0 }}></div>
//               )}
//             </Stack>

//             <IconButton onClick={handleDrawerClose}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//             <br />
//             <br />
//           </>
//         </DrawerHeader>

//         <br />
//         <br />
//         <Divider />
//         {openlogo && (
//           <Paper
//             component="form"
//             sx={{
//               m: "5px 5px",
//               p: "0px 2px",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <Autocomplete
//               freeSolo
//               fullWidth
//               size="small"
//               options={items.reduce((acc: any, item: any) => {
//                 if (item.items) {
//                   acc.push(...item.items.map((subItem: any) => subItem.menuName));
//                 }
//                 return acc;
//               }, [])}
//               onChange={handleAutocompleteChange}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   placeholder="Search Menu"
//                   variant="outlined"
//                   InputProps={{
//                     ...params.InputProps,
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <SearchIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                   onChange={handleSearchInputChange}
//                 />
//               )}
//             />
//           </Paper>
//         )}
//         <Divider />

//         <React.Fragment>
//           {/* Home List */}
//           <List sx={{ padding: 0 }}>
//             {["Home"].map((text, index) => (
//               <ListItem
//                 key={text}
//                 disablePadding
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   padding: 0,
//                   "&:hover": {
//                     cursor: "pointer",
//                     backgroundColor: "inherit",
//                   },
//                 }}
//               >
//                 <ListItemButton
//                   sx={{
//                     justifyContent: open ? "initial" : "center",
//                     px: 4.5,
//                     backgroundColor: "inherit"
//                   }}
//                   onClick={() => {
//                     routeChangeHome();
//                     resetHomeColor();
//                   }}
//                 >
//                   <ListItemIcon
//                     sx={{
//                       minWidth: 0,
//                       mr: open ? 1 : "auto",
//                       justifyContent: "center",
//                       color: homeColor,
//                     }}
//                   >
//                     <HomeIcon />
//                   </ListItemIcon>
//                   <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>

//           {/* Dynamic Items List */}
//           {renderMenu((filteredItems.length > 0) ? filteredItems : items)}




//         </React.Fragment>
//       </Drawer>
//       {/* <Box  sx={{ flexGrow: 1, p: 3 }}>
//         <DrawerHeader />
//       </Box> */}

//       <Modal open={isModalOpen} onClose={handleCloseModal}>
//         <Box sx={style}>
//           <Typography fontWeight={500} fontSize={20} noWrap align="center">
//             Node Permission
//           </Typography>
//           <div>
//             <Grid xs={12} item>
//               <Box>
//                 <div style={{ height: "400px", overflow: "auto" }}>
//                   <SimpleTreeView expandedItems={expandedItems}>
//                     {Array.isArray(treedata)
//                       ? treedata.map((node: any) => renderTree(node))
//                       : null}
//                   </SimpleTreeView>
//                 </div>
//               </Box>
//             </Grid>
//             <Grid xs={3} item alignItems="center" justifyContent="center">
//               <Button
//                 type="submit"
//                 fullWidth
//                 style={{
//                   backgroundColor: "#059669",
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 onClick={(e: any) => handleSave()}
//               >
//                 {t("text.save")}
//               </Button>
//             </Grid>
//           </div>
//         </Box>
//       </Modal>

//       <SwipeableDrawer
//         anchor="left"
//         open={profileDrawerOpen}
//         onClose={() => {
//           setProfileDrawerOpen(false);
//         }}
//         onOpen={() => { }}
//         style={{
//           zIndex: 1300,
//         }}
//       >
//         <Box sx={{ width: drawerWidth }} role="presentation">
//           <IconButton
//             edge="end"
//             onClick={() => setProfileDrawerOpen(false)}
//             aria-label="close"
//             sx={{ color: "white", position: "absolute", right: 15, top: 2 }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <p
//             style={{
//               paddingTop: "5vh",
//               paddingBottom: "5vh",
//               textAlign: "center",
//               backgroundImage:
//                 "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//               color: "whitesmoke",
//               borderBottomLeftRadius: "10px",
//               borderBottomRightRadius: "10px",
//               fontSize: "20px",
//             }}
//           >
//             User Details
//           </p>
//           {/* {userDetail.map((user: any, index: any) => (
//             <div key={index}>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <div
//                   style={{
//                     textAlign: "center",
//                     borderRadius: "50%",
//                     height: "90px",
//                     width: "90px",
//                     borderColor:
//                       "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//                     backgroundColor: "red",
//                     padding: "13px",
//                     paddingTop: "30px",
//                     paddingLeft: "13px",
//                     color: "whitesmoke",
//                     fontSize: "20px",
//                   }}
//                 >
//                   {getImageForFirstName(
//                     user.firsT_NAME,
//                     user.middlE_NAME,
//                     user.suR_NAME
//                   )}
//                 </div>
//               </div>
//               <div style={{ marginLeft: "15px" }}>
//                 {user.logiN_NAME && user.logiN_NAME.trim() !== "" && (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 20,
//                     }}
//                   >
//                     <img src={log} width={25} />
//                     {user.logiN_NAME}
//                   </div>
//                 )}
//                 <br />
//                 {user.rolename && user.rolename.trim() !== "" ? (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 10,
//                     }}
//                   >
//                     <img src={roles} width={25} />
//                     {user.rolename}
//                   </div>
//                 ) : (
//                   ""
//                 )}
//                 <br />
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 20,
//                   }}
//                 >
//                   <img src={names} width={25} />
//                   {user.firsT_NAME} {user.middlE_NAME} {user.suR_NAME}
//                 </div>
//                 <br />
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                   }}
//                 >
//                   {" "}
//                   <img src={dobs} width={22} />{" "}
//                   {dayjs(user.dob).format("YYYY-MM-DD")}
//                 </div>
//                 <br />
//                 {user.gendeR_ID !== 0 ? (
//                   <>
//                     {user.gendeR_ID && getGenderText(user.gendeR_ID) && (
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 10,
//                         }}
//                       >
//                         {" "}
//                         <img src={genders} width={22} />{" "}
//                         {getGenderText(user.gendeR_ID)}
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   " "
//                 )}

//                 <br />

//                 {user.cuR_MOBILE && user.cuR_MOBILE.trim() !== "" && (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 20,
//                     }}
//                   >
//                     <img src={call} width={25} />
//                     {user.cuR_MOBILE}
//                   </div>
//                 )}
//                 <br />

//                 {user.email && user.email.trim() !== "" && (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 20,
//                     }}
//                   >
//                     <img src={emails} width={25} />
//                     {user.email}
//                   </div>
//                 )}
//                 <br />

//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                   }}
//                 >
//                   Account Status :{" "}
//                   {user.iS_ACTIVE === true ? (
//                     <img src={tick} width={25} />
//                   ) : (
//                     <img src={crs} width={25} />
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))} */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginTop: "10px",
//               marginBottom: "10px",
//             }}
//           >
//             <div
//               style={{
//                 textAlign: "center",
//                 borderRadius: "50%",
//                 height: "90px",
//                 width: "90px",
//                 borderColor:
//                   "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
//                 backgroundColor: "red",
//                 padding: "13px",
//                 paddingTop: "30px",
//                 paddingLeft: "13px",
//                 color: "whitesmoke",
//                 fontSize: "20px",
//               }}
//             >
//               {getImageForFirstName(
//                 menuData.userName,


//               )}
//             </div>
//           </div>


//           <div >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 marginTop: "10px",
//                 marginBottom: "10px",
//               }}
//             >

//             </div>
//             <div style={{ marginLeft: "15px" }}>
//               {menuData.userName && menuData.userName.trim() !== "" && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 20,
//                   }}
//                 >
//                   <img src={log} width={25} />
//                   {menuData.userName}
//                 </div>
//               )}
//               <br />


//               <br />

//               {menuData.email && menuData.email.trim() !== "" && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 20,
//                   }}
//                 >
//                   <img src={emails} width={25} />
//                   {menuData.email}
//                 </div>
//               )}



//             </div>
//           </div>

//         </Box>
//       </SwipeableDrawer>
//     </Box>
//   );
// }
